import { useEffect, useState, useMemo, useRef, useDeferredValue } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import Swal from 'sweetalert2';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useMyContext } from '../../../context/MyContext';
import '../../../css/custom-scrollbar.css';
import FullPageLoader from '../../../component/fullPageLoader/fullPageLoader';
import { Base_Url, b2bAllShipmentList, b2bDeleteShipment, Url_For_View_Document, b2bLabel, b2bewaybill, b2bPriceEstimator, b2bWarehouseListAll, b2bAddShipment, b2bTrackShipment } from '../../../config/config';
import { CgSearch } from "react-icons/cg";
import { FaList, FaHourglassHalf, FaClipboardList, FaTruck, FaDownload, FaShippingFast, FaTimesCircle, FaExclamationCircle, FaCheckCircle, FaInfoCircle, FaPlus, FaBox } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import { SiZoho } from "react-icons/si";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { RxCross2 } from "react-icons/rx";
import { FaEye, FaCopy } from "react-icons/fa";
import { FcPrint } from "react-icons/fc";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdOutlineEventAvailable } from "react-icons/md";
import { TbRoute } from "react-icons/tb";
import {
    HiOutlineEye,
    HiOutlineDocumentDuplicate,
    HiOutlineRocketLaunch,
    HiOutlineXCircle,
    HiOutlinePrinter,
    HiOutlineArrowDownTray,
    HiOutlineCalendarDays,
    HiOutlineExclamationTriangle,
    HiOutlineArrowPath,
    HiOutlineDocumentText,
    HiChevronRight,
} from "react-icons/hi2";
import B2BViewRateForword from '../../../component/b2b/models/priceEstimatorModelB2b';
import B2BViewAllShipment from '../../../component/b2b/models/viewAllShipmentModel';
import axios from 'axios';
import AppointmentModal from '../../../component/b2b/models/appoimentModel';
import B2BTrackingSidePopup from '../../pages/B2BDashboard/B2BTrackingSidePopup';
import B2BForwordShipment from './b2bforwordShipment';
import B2BUploadBulk from '../../../component/b2b/models/uploadBulkModel';
import { FaDotCircle } from "react-icons/fa";

const TOAST_CONTAINER_ID = 'b2b-toast-container';

// ⚡ Shipments cache (stale-while-revalidate)
const SHIPMENT_CACHE_PREFIX = 'b2b_all_shipments_cache_';
const memoryShipmentCache = {};
const readShipmentCache = (cusId) => {
    const key = SHIPMENT_CACHE_PREFIX + (cusId || '');
    if (memoryShipmentCache[key]) return memoryShipmentCache[key];
    try {
        const rawSession = sessionStorage.getItem(key);
        if (rawSession) {
            const parsed = JSON.parse(rawSession);
            if (Array.isArray(parsed) && parsed.length > 0) {
                memoryShipmentCache[key] = parsed;
                return parsed;
            }
        }
    } catch (e) { }
    try {
        const raw = localStorage.getItem(key);
        const parsed = raw ? JSON.parse(raw) : null;
        if (Array.isArray(parsed) && parsed.length > 0) { memoryShipmentCache[key] = parsed; return parsed; }
    } catch (e) { }
    return null;
};
const writeShipmentCache = (cusId, data) => {
    const key = SHIPMENT_CACHE_PREFIX + (cusId || '');
    memoryShipmentCache[key] = data;
    try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (e) { }
    try { localStorage.setItem(key, JSON.stringify(data)); } catch (e) { }
};

const inFlightShipmentRequests = {};
const requestB2BAllShipments = (token, cusId, forceFresh = false) => {
    const key = cusId || '';
    if (forceFresh) {
        delete inFlightShipmentRequests[key];
    }
    if (inFlightShipmentRequests[key]) return inFlightShipmentRequests[key];
    const p = fetch(`${Base_Url}${b2bAllShipmentList}?page=1&limit=100000`, {
        method: 'GET',
        headers: { token: token || '', cus_id: cusId || '', 'Content-Type': 'application/json' },
    })
        .then(res => res.json())
        .finally(() => { delete inFlightShipmentRequests[key]; });
    inFlightShipmentRequests[key] = p;
    return p;
};

// ⚡ Fast search cache
const searchIndexCache = new WeakMap();
const getSearchText = (row) => {
    if (searchIndexCache.has(row)) return searchIndexCache.get(row);
    const text = Object.values(row)
        .filter(val => val !== null && val !== undefined)
        .join(' ')
        .toLowerCase();
    searchIndexCache.set(row, text);
    return text;
};

// ⚡ 19-digit standard Order ID generator (YYYYMMDDHHmmss + 5-digit random)
const generateStandardOrderId = () => {
    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const ts = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
    const rand = Math.floor(10000 + Math.random() * 90000);
    return `${ts}${rand}`;
};

// ⚡ Colorful gradient palette for user avatar
const avatarGradients = [
    'from-pink-500 to-rose-500',
    'from-orange-500 to-amber-500',
    'from-lime-500 to-green-500',
    'from-emerald-500 to-teal-500',
    'from-cyan-500 to-sky-500',
    'from-blue-500 to-indigo-500',
    'from-violet-500 to-purple-500',
    'from-fuchsia-500 to-pink-500',
    'from-red-500 to-orange-500',
    'from-teal-500 to-cyan-500',
    'from-indigo-500 to-blue-500',
    'from-purple-500 to-fuchsia-500',
];
const getAvatarGradient = (seed) => {
    const str = (seed || 'U').toString();
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % avatarGradients.length;
    return avatarGradients[index];
};

// ⚡ Colorful badge styling for B2B statuses
const getB2BStatusBadgeConfig = (status) => {
    if (!status) return {
        badgeClass: 'border-2 border-gray-300 bg-gray-50 text-gray-700 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300',
        label: '—'
    };
    const s = String(status).toLowerCase();

    if (s.includes('cancel')) return {
        badgeClass: 'border-2 border-red-500 bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-300 shadow-sm shadow-red-500/10',
        label: 'CN'
    };
    if (s.includes('fail')) return {
        badgeClass: 'border-2 border-rose-600 bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300 shadow-sm shadow-rose-500/10',
        label: 'FL'
    };
    if (s.includes('pending')) return {
        badgeClass: 'border-2 border-amber-400 bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300 shadow-sm shadow-amber-500/15',
        label: 'PD'
    };
    if (s.includes('deliver') || s.includes('complete')) return {
        badgeClass: 'border-2 border-emerald-500 bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300 shadow-sm shadow-emerald-500/15',
        label: 'DL'
    };
    if (s.includes('out_for_delivery') || s.includes('out for delivery') || s === 'ofd') return {
        badgeClass: 'border-2 border-sky-500 bg-sky-50 text-sky-800 dark:bg-sky-950/40 dark:text-sky-300 shadow-sm shadow-sky-500/15',
        label: 'OFD'
    };
    if (s.includes('manifest') || s === 'mf') return {
        badgeClass: 'border-2 border-purple-500 bg-purple-50 text-purple-800 dark:bg-purple-950/40 dark:text-purple-300 shadow-sm shadow-purple-500/15',
        label: 'MF'
    };
    if (s.includes('transit') || s === 'it') return {
        badgeClass: 'border-2 border-indigo-500 bg-indigo-50 text-indigo-800 dark:bg-indigo-950/40 dark:text-indigo-300 shadow-sm shadow-indigo-500/15',
        label: 'IT'
    };
    if (s.includes('left_origin') || s.includes('left origin') || s === 'lo') return {
        badgeClass: 'border-2 border-amber-500 bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300 shadow-sm shadow-amber-500/15',
        label: 'LO'
    };
    if (s.includes('rto')) return {
        badgeClass: 'border-2 border-rose-500 bg-rose-50 text-rose-700 dark:bg-rose-950/40 dark:text-rose-300 shadow-sm shadow-rose-500/10',
        label: 'RTO'
    };
    if (s.includes('appointment') || s.includes('slot')) return {
        badgeClass: 'border-2 border-violet-500 bg-violet-50 text-violet-800 dark:bg-violet-950/40 dark:text-violet-300 shadow-sm shadow-violet-500/15',
        label: 'APT'
    };

    const short = status.replace(/_/g, " ").split(" ").map(w => w[0]).join("").slice(0, 3).toUpperCase();
    return {
        badgeClass: 'border-2 border-slate-400 bg-slate-50 text-slate-800 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200 shadow-sm',
        label: short || 'ST'
    };
};

// ⚡ Appointment shipment checker (Checks real appointment data from API/database)
const isAppointmentShipment = (item) => {
    if (!item) return false;
    const hasApptDate = item.appointment_date && String(item.appointment_date).trim() !== '' && item.appointment_date !== 'null' && item.appointment_date !== 'undefined';
    const hasApptSlot = item.appointment_slot && String(item.appointment_slot).trim() !== '' && item.appointment_slot !== 'null' && item.appointment_slot !== 'undefined';
    const hasApptId = item.appointment_id && String(item.appointment_id).trim() !== '' && item.appointment_id !== 'null' && item.appointment_id !== 'undefined';
    const hasApptOrder = item.appointment_order_id && String(item.appointment_order_id).trim() !== '' && item.appointment_order_id !== 'null' && item.appointment_order_id !== 'undefined';
    const hasApptObj = Boolean(item.appointment && typeof item.appointment === 'object');
    const isApptFlag = item.is_appointment === true || item.is_appointment === 1 || String(item.is_appointment).toLowerCase() === 'true';
    const statusHasAppt = typeof item.status === 'string' && (item.status.toLowerCase().includes('appointment') || item.status.toLowerCase().includes('slot'));
    return Boolean(hasApptDate || hasApptSlot || hasApptId || hasApptOrder || hasApptObj || isApptFlag || statusHasAppt);
};

// ⚡ In-transit shipment checker
const isTransitShipment = (item) => {
    if (!item) return false;
    const rawStatus = item.status || item.order_status || item.shipment_status || item.current_status || '';
    const s = String(rawStatus).toLowerCase().trim();
    if (!s) return false;
    return (
        s.includes('transit') ||
        s.includes('left_origin') ||
        s.includes('left origin') ||
        s.includes('reach_destination') ||
        s.includes('reach destination') ||
        s.includes('out_for_delivery') ||
        s.includes('out for delivery') ||
        s.includes('ofd') ||
        s.includes('dispatched') ||
        s.includes('shipped') ||
        s === 'it' ||
        s === 'lo'
    );
};

// ⚡ B2B Local Clones Cleanup
const B2B_LOCAL_CLONES_KEY = 'b2b_local_cloned_orders';
const removeB2BLocalClone = (orderId) => {
    try {
        const raw = localStorage.getItem(B2B_LOCAL_CLONES_KEY);
        const existing = raw ? JSON.parse(raw) : [];
        if (Array.isArray(existing) && existing.length > 0) {
            const updated = existing.filter(i => String(i.order_id) !== String(orderId));
            localStorage.setItem(B2B_LOCAL_CLONES_KEY, JSON.stringify(updated));
        }
    } catch (e) { }
};

const B2bAllShipmentList = () => {
    const { selectedCft, isDarkMode, isToggleSidebar, setorderId } = useMyContext();

    const [allData, setAllData] = useState(() => {
        try { localStorage.removeItem(B2B_LOCAL_CLONES_KEY); } catch (e) { }
        return readShipmentCache(localStorage.getItem('cus_id')) || [];
    });
    const allDataRef = useRef(allData);
    useEffect(() => { allDataRef.current = allData; }, [allData]);
    const isCloningRef = useRef(false);

    const [loadingOrderId, setLoadingOrderId] = useState(null);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [isloading, isSetLoading] = useState(false);
    const [isMobileCardView, setIsMobileCardView] = useState(false);

    const [activeTab, setActiveTab] = useState('all orders');
    const [searchTerm, setSearchTerm] = useState('');
    const deferredSearchTerm = useDeferredValue(searchTerm);

    const [currentPage, setCurrentPage] = useState(1);
    const limit = 15;
    const [shipData, setShipData] = useState();
    const [openAppointmentModal, setOpenAppointmentModal] = useState(false);
    const [isPopupOpenEdit, setIsPopupOpenEdit] = useState(false);
    const [appoimentOrderId, setAppoimentorderId] = useState();
    const [appointmentShipmentData, setAppointmentShipmentData] = useState(null);

    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedShipment, setSelectedShipment] = useState(null);

    const [isViewOpen, setIsViewOpen] = useState(false);
    const [isEstimatorOpen, setIsEstimatorOpen] = useState(false);

    const [isTrackingPopupOpen, setIsTrackingPopupOpen] = useState(false);
    const [trackingPopupSearchTerm, setTrackingPopupSearchTerm] = useState('');

    const [showSizeDropdown, setShowSizeDropdown] = useState(null);
    const [showActionDropdown, setShowActionDropdown] = useState(null);
    const [actionDropdownPos, setActionDropdownPos] = useState({ x: 0, y: 0 });

    const [loadingOrderIdCancleOrder, setLoadingOrderIdCancleOrder] = useState(null);
    const [loadingOrderIdShip, setLoadingOrderIdShip] = useState(null);
    const [refreshingOrderId, setRefreshingOrderId] = useState(null);
    const [wareHouseList, setwareHouseList] = useState([]);

    const [failedReasonPopup, setFailedReasonPopup] = useState({ open: false, reason: '', orderId: '' });

    const [hoverCardPos, setHoverCardPos] = useState({ id: null, x: 0, y: 0, above: false });
    const [addrHover, setAddrHover] = useState({ id: null, type: null, x: 0, y: 0, above: false });
    const [weightHover, setWeightHover] = useState({ id: null, x: 0, y: 0, above: false });
    const [typeHover, setTypeHover] = useState({ id: null, label: '', x: 0, y: 0, above: false });
    const [statusHover, setStatusHover] = useState({ id: null, label: '', x: 0, y: 0, above: false });
    const [productHover, setProductHover] = useState({ id: null, x: 0, y: 0, above: false });
    const [hoverData, setHoverData] = useState({});

    const [isAddShipmentOpen, setIsAddShipmentOpen] = useState(false);

    const [uploadBulkPopupOpen, setUploadBulkPopupOpen] = useState(false);
    const UploadBulkViewClick = () => setUploadBulkPopupOpen(true);
    const handleCloseUploadBulk = () => setUploadBulkPopupOpen(false);

    const modelcloseAppoiment = () => setOpenAppointmentModal(false);
    const handleCloseEdit = () => setIsPopupOpenEdit(false);

    const handleUserMouseEnter = (e, rowId, rowData, pickup) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const above = spaceBelow < 280;
        setHoverCardPos({ id: rowId, x: rect.left, y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY, above });
        setHoverData(prev => ({ ...prev, [`user_${rowId}`]: { rowData, pickup } }));
    };
    const handleUserMouseLeave = () => setHoverCardPos({ id: null, x: 0, y: 0, above: false });

    const handleAddrEnter = (e, rowId, type, locationData) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const above = spaceBelow < 260;
        setAddrHover({ id: rowId, type, x: rect.left, y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY, above });
        setHoverData(prev => ({ ...prev, [`addr_${rowId}_${type}`]: locationData }));
    };
    const handleAddrLeave = () => setAddrHover({ id: null, type: null, x: 0, y: 0, above: false });

    const handleWeightEnter = (e, rowId, rowData) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const above = spaceBelow < 180;
        setWeightHover({ id: rowId, x: rect.left + rect.width / 2, y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY, above });
        setHoverData(prev => ({ ...prev, [`weight_${rowId}`]: rowData }));
    };
    const handleWeightLeave = () => setWeightHover({ id: null, x: 0, y: 0, above: false });

    const handleTypeEnter = (e, rowId, label) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const above = spaceBelow < 60;
        setTypeHover({ id: rowId, label, x: rect.left + rect.width / 2, y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY, above });
    };
    const handleTypeLeave = () => setTypeHover({ id: null, label: '', x: 0, y: 0, above: false });

    const handleStatusEnter = (e, rowId, label) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const above = spaceBelow < 60;
        setStatusHover({ id: rowId, label, x: rect.left + rect.width / 2, y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY, above });
    };
    const handleStatusLeave = () => setStatusHover({ id: null, label: '', x: 0, y: 0, above: false });

    const handleProductEnter = (e, rowId, rowData) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;
        const above = spaceBelow < 220;
        setProductHover({ id: rowId, x: rect.left, y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY, above });
        setHoverData(prev => ({ ...prev, [`product_${rowId}`]: rowData }));
    };
    const handleProductLeave = () => setProductHover({ id: null, x: 0, y: 0, above: false });

    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    const userRole = localStorage.getItem("role") || localStorage.getItem("user_role") || "";
    const isAdmin = userRole?.toLowerCase() === "admin";
    const navigateForTrack = useNavigate();

    useEffect(() => {
        const checkScreen = () => setIsMobileCardView(window.innerWidth < 768);
        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    useEffect(() => {
        fetchAllShipments();
        fetchWareHouseList();
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (showActionDropdown && !e.target.closest('.action-dropdown-wrapper')) {
                setShowActionDropdown(null);
            }
            if (showSizeDropdown && !e.target.closest('.size-dropdown-wrapper')) {
                setShowSizeDropdown(null);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showActionDropdown, showSizeDropdown]);

    useEffect(() => {
        if (!showActionDropdown) return;
        const handleScroll = () => setShowActionDropdown(null);
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, [showActionDropdown]);

    const fetchAllShipments = async (forceFresh = false) => {
        const showLoader = allDataRef.current.length === 0;
        try {
            if (showLoader) {
                setIsPageLoading(true);
            }

            const result = await requestB2BAllShipments(token, cusid, forceFresh);
            const freshData = result?.data || [];
            // Clean up any stale fake clones so only real server shipments show
            try { localStorage.removeItem(B2B_LOCAL_CLONES_KEY); } catch (e) { }

            // ⚡ Sort orders by date descending so the newest orders are always at the top!
            const merged = freshData.sort((a, b) => {
                const tA = a.created_at ? new Date(a.created_at).getTime() : 0;
                const tB = b.created_at ? new Date(b.created_at).getTime() : 0;
                return tB - tA;
            });

            setAllData(merged);
            writeShipmentCache(cusid, merged);
        } catch (err) {
            toast.error("Failed to load shipments", { containerId: TOAST_CONTAINER_ID });
        } finally {
            setIsPageLoading(false);
        }
    };

    const fetchWareHouseList = async () => {
        try {
            const response = await fetch(Base_Url + b2bWarehouseListAll, {
                headers: { token, cus_id: cusid, 'Content-Type': 'application/json' }
            });
            const data = await response.json();
            const list = data?.data || data?.warehouses || data?.result || [];
            setwareHouseList(list);
            if (Array.isArray(list) && list.length > 0) {
                try { localStorage.setItem('b2b_cached_warehouses', JSON.stringify(list)); } catch (e) { }
            }
        } catch (error) {
            console.error(error);
        }
    };

    const copyToClipboard = (text, label) => {
        navigator.clipboard.writeText(text);
        toast.success(`${label} copied!`, { containerId: TOAST_CONTAINER_ID, position: "top-right", autoClose: 2000 });
    };

    const handleBookAppointment = (row) => {
        setAppoimentorderId(row.order_id);
        setAppointmentShipmentData(row);
        setOpenAppointmentModal(true);
    };

    const handleDownloadPOD = async (row) => {
        setShowActionDropdown(null);
        setIsPageLoading(true);
        try {
            const response = await fetch(`${Base_Url}B2B/shipment/getEpod/${row.order_id}`, {
                method: 'GET',
                headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
            });
            const data = await response.json();
            const fileUrl = data?.data?.files?.[0]?.url;

            if (data?.status === 'SUCCESS' && fileUrl) {
                window.open(fileUrl, '_blank', 'noopener,noreferrer');
                toast.success('POD downloaded successfully!', { containerId: TOAST_CONTAINER_ID });
            } else {
                Swal.fire({
                    icon: 'info', title: 'POD Not Available',
                    text: data?.message || `POD (e-POD) for Order #${row?.order_id} is currently not available.`,
                    confirmButtonText: 'OK',
                });
            }
        } catch (error) {
            toast.error('Failed to fetch POD', { containerId: TOAST_CONTAINER_ID });
        } finally {
            setIsPageLoading(false);
        }
    };

    const getTabCount = (tabKey) => {
        return allData.filter(item => {
            if (tabKey === 'all orders') return true;
            if (tabKey === 'Add Shipment list' || tabKey === 'pending')
                return item.status?.toLowerCase().includes('pending') || item.status?.toLowerCase() === 'manifest pending';
            if (tabKey === 'new order')
                return item.status?.toLowerCase().includes('new') || item.status?.toLowerCase() === 'manifest pending';
            if (tabKey === 'process order' || tabKey === 'in transit')
                return isTransitShipment(item);
            if (tabKey === 'manifest list')
                return item.status?.toLowerCase() === 'manifested' || item.status?.toLowerCase() === 'manifest';
            if (tabKey === 'appointment')
                return isAppointmentShipment(item);
            if (tabKey === 'delivered')
                return item.status?.toLowerCase().includes('delivered');
            if (tabKey === 'failed')
                return item.status?.toLowerCase().includes('failed');
            if (tabKey === 'zoho')
                return item.partner?.toLowerCase() === 'zoho';
            return false;
        }).length;
    };

    const filteredData = useMemo(() => {
        let data = [...allData];
        switch (activeTab) {
            case 'appointment':
                data = data.filter(item => isAppointmentShipment(item));
                break;
            case 'Add Shipment list':
            case 'pending':
                data = data.filter(item => item.status?.toLowerCase().includes('pending') || item.status?.toLowerCase() === 'manifest pending');
                break;
            case 'new order':
                data = data.filter(item => item.status?.toLowerCase().includes('new') || item.status?.toLowerCase() === 'manifest pending');
                break;
            case 'process order':
            case 'in transit':
                data = data.filter(item => isTransitShipment(item));
                break;
            case 'manifest list':
                data = data.filter(item => item.status?.toLowerCase() === 'manifested' || item.status?.toLowerCase() === 'manifest');
                break;
            case 'delivered':
                data = data.filter(item => item.status?.toLowerCase().includes('delivered'));
                break;
            case 'failed':
                data = data.filter(item => item.status?.toLowerCase().includes('failed'));
                break;
            case 'zoho':
                data = data.filter(item => item.partner?.toLowerCase() === 'zoho');
                break;
            default:
                break;
        }
        if (deferredSearchTerm.trim()) {
            const term = deferredSearchTerm.toLowerCase();
            data = data.filter(row => getSearchText(row).includes(term));
        }
        return data;
    }, [allData, activeTab, deferredSearchTerm]);

    const paginatedData = filteredData.slice((currentPage - 1) * limit, currentPage * limit);
    const totalPages = Math.ceil(filteredData.length / limit);

    useEffect(() => setCurrentPage(1), [activeTab, deferredSearchTerm]);

    const handleViewClick = (row) => { setSelectedShipment(row); setIsViewOpen(true); };

    const handleOpenTrackingPopup = (row) => {
        setTrackingPopupSearchTerm(row?.order_id || '');
        setIsTrackingPopupOpen(true);
    };

    const handleClick = (row) => {
        const isPending = row.status?.toLowerCase().includes('pending') || row.status?.toLowerCase() === 'manifest pending';
        const hasWaybill = !!(row.waybill || row.lrn);
        if (isPending || !hasWaybill) {
            toast.warning("Tracking available only after shipment is processed and AWB is generated.", { containerId: TOAST_CONTAINER_ID });
            return;
        }
        setorderId(row.order_id);
        navigateForTrack("/b2b/shipment/track");
    };

    const handleCancelOrder = async (orderId) => {
        const confirmResult = await Swal.fire({
            title: 'Are you sure?', text: "Do you want to cancel this order?", icon: 'warning',
            showCancelButton: true, confirmButtonColor: '#d33', confirmButtonText: 'Yes, cancel it!',
        });
        if (!confirmResult.isConfirmed) return;
        setIsPageLoading(true);
        try {
            const response = await fetch(`${Base_Url}${b2bDeleteShipment}/${orderId}`, {
                method: 'GET', headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
            });
            if (response.ok) {
                removeB2BLocalClone(orderId);
                setAllData(prev => prev.filter(item => item.order_id !== orderId));
                toast.success("Order canceled successfully!", { containerId: TOAST_CONTAINER_ID });
            }
        } catch (error) {
            removeB2BLocalClone(orderId);
            setAllData(prev => prev.filter(item => item.order_id !== orderId));
            toast.error("Failed to cancel order", { containerId: TOAST_CONTAINER_ID });
        } finally {
            setIsPageLoading(false);
        }
    };

    // ⚡ Real order has already been created on backend; refresh list with real server data
    const handleShipmentCreated = () => {
        try { localStorage.removeItem(B2B_LOCAL_CLONES_KEY); } catch (e) { }
        fetchAllShipments(true);
    };

    const handleBulkOrdersCreated = () => {
        try { localStorage.removeItem(B2B_LOCAL_CLONES_KEY); } catch (e) { }
        fetchAllShipments(true);
    };

    const handleRefreshStatus = async (row) => {
        if (!row) return;
        setShowActionDropdown(null);
        setIsPageLoading(true);
        const toastId = toast.loading ? toast.loading("Refreshing shipment status...", { containerId: TOAST_CONTAINER_ID }) : null;
        try {
            const trackTarget = row.order_id || row.waybill || row.lrn;
            if (trackTarget) {
                try {
                    await axios.post(
                        Base_Url + b2bTrackShipment,
                        { order_id: trackTarget, shipment_type: 'Forward' },
                        {
                            headers: {
                                token: token || localStorage.getItem('token') || '',
                                cus_id: cusid || localStorage.getItem('cus_id') || '',
                                'Content-Type': 'application/json',
                            },
                        }
                    );
                } catch (trackErr) {
                    console.warn("Track sync note:", trackErr);
                }
            }
            await fetchAllShipments(true);
            if (toastId) toast.dismiss(toastId);
            toast.success("Shipment status refreshed!", { containerId: TOAST_CONTAINER_ID });
        } catch (err) {
            console.error("Failed to refresh status:", err);
            if (toastId) toast.dismiss(toastId);
            toast.error("Failed to refresh shipment status", { containerId: TOAST_CONTAINER_ID });
        } finally {
            setIsPageLoading(false);
        }
    };

    const handleCloneOrder = async (row) => {
        if (!row || isCloningRef.current) return;
        isCloningRef.current = true;
        setIsPageLoading(true);
        const newOrderId = generateStandardOrderId();

        // ⚡ Hit B2B Add Shipment API (exact same as Add Shipment)
        try {
            let dropoff = {};
            try {
                dropoff = typeof row.dropoff_location === 'object' && row.dropoff_location !== null
                    ? row.dropoff_location
                    : JSON.parse(row.dropoff_location || '{}');
            } catch (e) { dropoff = {}; }

            let invoices = [];
            try {
                invoices = typeof row.invoices === 'object' && row.invoices !== null
                    ? (Array.isArray(row.invoices) ? row.invoices : [row.invoices])
                    : JSON.parse(row.invoices || '[]');
            } catch (e) { invoices = []; }
            if (!Array.isArray(invoices) || invoices.length === 0) {
                invoices = [{
                    ewaybill: row.ewaybill || row.e_waybill || '',
                    inv_num: row.invoice_num || row.invoice_number || '',
                    inv_amt: row.amount || row.debit_amount || row.invoice_amount || 0,
                    inv_qr_code: ''
                }];
            } else {
                invoices = invoices.map(inv => ({
                    ...inv,
                    inv_num: inv.inv_num || inv.invoice_num || row.invoice_number || row.invoice_num || '',
                    inv_amt: inv.inv_amt !== undefined && inv.inv_amt !== '' ? inv.inv_amt : (row.amount || row.debit_amount || 0),
                    inv_qr_code: ''
                }));
            }

            let shipmentDetails = [];
            try {
                shipmentDetails = typeof row.shipment_details === 'object' && row.shipment_details !== null
                    ? (Array.isArray(row.shipment_details) ? row.shipment_details : [row.shipment_details])
                    : JSON.parse(row.shipment_details || '[]');
            } catch (e) { shipmentDetails = []; }
            if (!Array.isArray(shipmentDetails) || shipmentDetails.length === 0) {
                shipmentDetails = [{
                    order_id: newOrderId,
                    box_count: parseInt(row.total_boxes) || 1,
                    description: row.product_desc || row.description || 'General Goods',
                    weight: parseFloat(row.total_weight) || 10,
                    waybills: [],
                    master: "False"
                }];
            } else {
                shipmentDetails = shipmentDetails.map(sd => ({
                    ...sd,
                    order_id: newOrderId,
                    waybills: [],
                    master: "False"
                }));
            }

            let dimensions = [];
            try {
                const rawDims = typeof row.dimensions === 'object' && row.dimensions !== null
                    ? (Array.isArray(row.dimensions) ? row.dimensions : [row.dimensions])
                    : JSON.parse(row.dimensions || '[]');
                if (Array.isArray(rawDims) && rawDims.length > 0) {
                    dimensions = rawDims.map(d => ({
                        box_count: parseInt(d.box_count || d.quantity || 1),
                        length: parseFloat(d.length || d.total_length || 10),
                        width: parseFloat(d.width || d.total_width || 10),
                        height: parseFloat(d.height || d.total_height || 10)
                    }));
                }
            } catch (e) { dimensions = []; }
            if (dimensions.length === 0) {
                dimensions = [{
                    box_count: parseInt(row.total_boxes || 1),
                    length: parseFloat(row.total_length || row.length || 10),
                    width: parseFloat(row.total_width || row.width || 10),
                    height: parseFloat(row.total_height || row.height || 10)
                }];
            }

            const clonedInvoiceNum = invoices[0]?.inv_num || row.invoice_number || row.invoice_num || '';
            const docData = [{
                doc_type: "INVOICE_COPY",
                doc_meta: {
                    invoice_num: [clonedInvoiceNum || newOrderId]
                }
            }];

            let billingAddress = {};
            try {
                billingAddress = typeof row.billing_address === 'object' && row.billing_address !== null
                    ? row.billing_address
                    : JSON.parse(row.billing_address || '{}');
            } catch (e) { billingAddress = {}; }
            if (!billingAddress || Object.keys(billingAddress).length === 0) {
                billingAddress = {
                    name: dropoff.consignee_name || 'Retailer',
                    company: "pickupxpress",
                    consignor: dropoff.consignee_name || 'Retailer',
                    address: dropoff.address || 'Warehouse',
                    city: dropoff.city || 'Delhi',
                    state: dropoff.state || 'Delhi',
                    pin: dropoff.zip || '110001',
                    phone: dropoff.phone || '9999999999',
                    pan_number: "ABCDE1234F",
                    gst_number: "09AAACH7409R1ZZ"
                };
            }

            // ⚡ Resolve valid warehouse_id
            let resolvedWarehouseId = row.warehouse_id || row.warehouseId || row.wh_id;
            if (!resolvedWarehouseId) {
                let pickupLoc = {};
                try {
                    pickupLoc = typeof row.pickup_location === 'object' && row.pickup_location !== null
                        ? row.pickup_location
                        : JSON.parse(row.pickup_location || '{}');
                } catch (e) { }

                resolvedWarehouseId = pickupLoc.warehouse_id || pickupLoc.id || pickupLoc.warehouseId;

                let whList = wareHouseList;
                if (!whList || whList.length === 0) {
                    try {
                        const whRes = await fetch(Base_Url + b2bWarehouseListAll, {
                            headers: { token, cus_id: cusid, 'Content-Type': 'application/json' }
                        });
                        const whData = await whRes.json();
                        whList = whData?.data || whData?.warehouses || whData?.result || [];
                        if (whList.length > 0) setwareHouseList(whList);
                    } catch (e) { }
                }

                if (!resolvedWarehouseId && whList && whList.length > 0) {
                    const pickupName = (pickupLoc.consignee_name || pickupLoc.name || row.retailer_name || '').toLowerCase().trim();
                    const pickupZip = String(pickupLoc.zip || pickupLoc.pincode || '').trim();
                    const matched = whList.find(wh =>
                        (wh.name && wh.name.toLowerCase().trim() === pickupName) ||
                        (wh.pincode && String(wh.pincode).trim() === pickupZip)
                    );
                    resolvedWarehouseId = matched
                        ? (matched.warehouse_id ?? matched.id ?? matched.value)
                        : (whList[0]?.warehouse_id ?? whList[0]?.id ?? whList[0]?.value);
                }
            }

            // ⚡ Backend strictly validates type in: [6, 10, 15]
            const resolveB2BCftType = (val) => {
                if (!val) return "6";
                const str = String(val).trim().toLowerCase();
                if (str === 'dense' || str === 'dn' || str === '15') return "15";
                if (str === 'heavy' || str === 'hv' || str === '10') return "10";
                if (str === 'lite' || str === 'lt' || str === '6') return "6";
                const num = Number(str);
                if (!isNaN(num) && [6, 10, 15].includes(num)) return String(num);
                return "6";
            };
            const resolvedType = resolveB2BCftType(row.type || row.shipment_type || selectedCft);

            if (!dropoff.consignee_name) dropoff.consignee_name = row.user_name || row.retailer_name || 'Customer';
            if (!dropoff.address) dropoff.address = 'Consignee Delivery Address';
            if (!dropoff.city) dropoff.city = 'Delhi';
            if (!dropoff.state) dropoff.state = 'Delhi';
            if (!dropoff.zip) dropoff.zip = '110001';
            if (!dropoff.phone) dropoff.phone = '9876543210';
            if (!dropoff.email) dropoff.email = 'customer@pickupxpress.com';

            const formData = new FormData();
            formData.append('warehouse_id', String(resolvedWarehouseId || '1'));
            formData.append('type', resolvedType);
            formData.append('total_boxes', String(row.total_boxes || 1));
            formData.append('payment_mode', row.payment_mode || 'prepaid');
            formData.append('cod_amount', String(row.cod_amount || '0'));
            formData.append('total_weight', String(row.total_weight || '10'));
            formData.append('dropoff_location', JSON.stringify(dropoff));
            formData.append('invoices', JSON.stringify(invoices));
            formData.append('shipment_details', JSON.stringify(shipmentDetails));
            formData.append('dimensions', JSON.stringify(dimensions));
            formData.append('doc_data', JSON.stringify(docData));
            formData.append('billing_address', JSON.stringify(billingAddress));
            formData.append('insurence', row.insurence || 'Owner');
            formData.append('fm_pickup', 'True');
            formData.append('retailer_id', '2');

            const res = await axios.post(Base_Url + b2bAddShipment, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    'token': token || localStorage.getItem('token') || '',
                    'cus_id': cusid || localStorage.getItem('cus_id') || '',
                },
            });

            if (res.data?.status === "SUCCESS" || res.status === 200) {
                // Clear any old fake clones so table only displays real server data
                try { localStorage.removeItem(B2B_LOCAL_CLONES_KEY); } catch (e) { }
                await fetchAllShipments(true);
                toast.success(`Order cloned with Order ID #${newOrderId}!`, { containerId: TOAST_CONTAINER_ID });
            } else {
                toast.error(res.data?.message || "Failed to clone order on server", { containerId: TOAST_CONTAINER_ID });
            }
        } catch (apiErr) {
            console.warn("B2B Clone API error:", apiErr);
            if (apiErr.response?.data?.messages) {
                const msgs = Object.values(apiErr.response.data.messages).join(' | ');
                toast.error(msgs, { containerId: TOAST_CONTAINER_ID });
            } else {
                toast.error(apiErr.response?.data?.message || "Failed to clone order", { containerId: TOAST_CONTAINER_ID });
            }
        } finally {
            isCloningRef.current = false;
            setIsPageLoading(false);
        }
    };

    const handlePrintLabel = async (orderId, size = "A4") => {
        setIsPageLoading(true);
        try {
            const response = await fetch(`${Base_Url}${b2bLabel}`, {
                method: 'POST', headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
                body: JSON.stringify({ order_id: orderId, size }),
            });
            const data = await response.json();
            if (data.label_link) {
                window.open(data.label_link, '_blank');
                toast.success("Label opened successfully!", { containerId: TOAST_CONTAINER_ID });
            } else {
                toast.error("No label found", { containerId: TOAST_CONTAINER_ID });
            }
        } catch (error) {
            toast.error('Failed to generate label', { containerId: TOAST_CONTAINER_ID });
        } finally {
            setIsPageLoading(false);
            setShowSizeDropdown(null);
        }
    };

    const handleDownloadWaybill = async (orderId) => {
        setIsPageLoading(true);
        try {
            const response = await fetch(`${Base_Url}${b2bewaybill}`, {
                method: 'POST', headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
                body: JSON.stringify({ order_id: orderId, size: "A4" }),
            });
            const data = await response.json();
            if (data.order_id) {
                const labelUrl = data?.document_label?.label_link || data?.box_labels?.[0]?.label_link;
                if (labelUrl) {
                    window.open(labelUrl, '_blank');
                    toast.success("Shipment label opened successfully!", { containerId: TOAST_CONTAINER_ID });
                } else {
                    toast.error("No label link found in response.", { containerId: TOAST_CONTAINER_ID });
                }
                setIsPageLoading(false);
                setLoadingOrderId(null);
            } else {
                toast.error(data.message || "Failed to generate label", { containerId: TOAST_CONTAINER_ID });
                setLoadingOrderId(null);
                setIsPageLoading(false);
            }
        } catch (error) {
            toast.error('Failed to generate waybill', { containerId: TOAST_CONTAINER_ID });
        } finally {
            setIsPageLoading(false);
            setShowSizeDropdown(null);
        }
    };

    const hanldeShipNow = async (order) => {
        if (!order.status?.toLowerCase().includes('pending')) {
            toast.error("Only Pending orders can be shipped", { containerId: TOAST_CONTAINER_ID });
            return;
        }
        setLoadingOrderIdShip(order.order_id);
        setIsPageLoading(true);
        const apiUrl = Base_Url + b2bPriceEstimator;
        const headers = { cus_id: cusid, token: token, "Content-Type": "application/json" };
        const pickupLocation = JSON.parse(order.pickup_location || '{}');
        const dropoffLocation = JSON.parse(order.dropoff_location || '{}');
        const invoices = JSON.parse(order.invoices || "[]");

        // Map shipment_type (LITE / HEAVY / DENSE) to numeric CFT (6, 10, 15)
        const getNumericCft = (type) => {
            if (!type) return 6;
            const str = String(type).trim().toLowerCase();
            if (str === 'dense' || str === 'dn' || str === '15') return 15;
            if (str === 'heavy' || str === 'hv' || str === '10') return 10;
            if (str === 'lite' || str === 'lt' || str === '6') return 6;
            const num = Number(str);
            if (!isNaN(num) && [6, 10, 15].includes(num)) return num;
            return 6;
        };
        const numericCft = getNumericCft(order.shipment_type || order.type || order.cft);

        // Parse box dimensions properly
        let parsedDimensions = [];
        try {
            const rawDims = typeof order.dimensions === 'string' ? JSON.parse(order.dimensions || '[]') : (order.dimensions || []);
            if (Array.isArray(rawDims) && rawDims.length > 0) {
                parsedDimensions = rawDims.map(d => ({
                    quantity: parseInt(d.box_count || d.quantity || 1),
                    total_length: parseFloat(d.length || d.total_length || 0),
                    total_width: parseFloat(d.width || d.total_width || 0),
                    total_height: parseFloat(d.height || d.total_height || 0),
                }));
            }
        } catch (e) { }

        if (parsedDimensions.length === 0) {
            parsedDimensions = [{
                quantity: parseInt(order.total_boxes || 1),
                total_length: parseFloat(order.total_length || 0),
                total_width: parseFloat(order.total_width || 0),
                total_height: parseFloat(order.total_height || 0),
            }];
        }

        const invoiceAmount = invoices.length > 0 ? parseFloat(invoices[0].inv_amt) : 0;
        const payload = {
            retailer_id: parseInt(order.retailer_id),
            origin_pincode: pickupLocation.zip,
            destination_pincode: dropoffLocation.zip,
            insorance: order.insurence,
            weight: parseFloat(order.total_weight),
            invoice_value: invoiceAmount,
            cft: numericCft,
            dimensions: parsedDimensions,
        };
        try {
            const response = await axios.post(apiUrl, payload, { headers });
            if (response.data.status === "success") {
                setShipData(response.data);
                setSelectedShipment(order);
                setIsEstimatorOpen(true);
                setIsPageLoading(false);
            } else {
                const errorMessage = response.data?.message || response.data?.messages?.error || response.data?.error || "Something went wrong";
                setIsPageLoading(false);
                toast.error(errorMessage, { containerId: TOAST_CONTAINER_ID });
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.response?.data?.messages?.error || error.response?.data?.error || error.message;
            setIsPageLoading(false);
            toast.error("API Error: " + errorMessage, { containerId: TOAST_CONTAINER_ID });
        } finally {
            setLoadingOrderIdShip(null);
            setIsPageLoading(false);
        }
    };

    const handleShipNowSuccess = async (orderId) => {
        const targetId = orderId || selectedShipment?.order_id;
        if (targetId) {
            setRefreshingOrderId(targetId);
        }
        try {
            await fetchAllShipments(true);
            setTimeout(async () => {
                await fetchAllShipments(true);
                setRefreshingOrderId(null);
            }, 1000);
        } catch (e) {
            console.error("Failed to refresh shipment after ship now:", e);
            setRefreshingOrderId(null);
        }
    };

    const handleShowFailedReason = (row) => {
        const reason = row.remarks || row.failed_reason || row.failure_reason || row.cancel_reason || row.remark || "No reason provided";
        setFailedReasonPopup({ open: true, reason, orderId: row.order_id });
    };

    const getStatusStyle = (status) => {
        if (!status) return 'bg-gray-100 text-gray-600';
        const s = status.toLowerCase();
        if (s.includes('failed')) return 'bg-red-100 text-red-700';
        if (s.includes('pending') || s.includes('manifest pending')) return 'bg-yellow-100 text-yellow-700';
        if (s.includes('delivered') || s.includes('completed')) return 'bg-emerald-100 text-emerald-700';
        return 'bg-blue-100 text-blue-700';
    };

    // Mobile status pill colors (glassy look)
    const getMobileStatusStyle = (status) => {
        if (!status) return 'bg-gray-500/15 text-gray-600 dark:text-gray-300 border-gray-400/30';
        const s = status.toLowerCase();
        if (s.includes('cancel')) return 'bg-red-500/15 text-red-600 dark:text-red-300 border-red-400/40';
        if (s.includes('failed')) return 'bg-black/80 text-white border-black/60 dark:bg-red-500/20 dark:text-red-300 dark:border-red-400/40';
        if (s.includes('pending') || s.includes('manifest pending')) return 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-400/40';
        if (s.includes('delivered') || s.includes('completed')) return 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-400/40';
        if (s.includes('in_transit') || s.includes('transit')) return 'bg-indigo-500/15 text-indigo-700 dark:text-indigo-300 border-indigo-400/40';
        if (s.includes('out_for_delivery') || s.includes('ofd')) return 'bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-400/40';
        if (s.includes('left_origin')) return 'bg-cyan-500/15 text-cyan-700 dark:text-cyan-300 border-cyan-400/40';
        if (s.includes('reach_destination')) return 'bg-purple-500/15 text-purple-700 dark:text-purple-300 border-purple-400/40';
        return 'bg-gray-500/15 text-gray-600 dark:text-gray-300 border-gray-400/30';
    };

    const tabs = [
        { key: "all orders", label: "All Orders", icon: <FaList /> },
        { key: "Add Shipment list", label: "Pending", icon: <FaTruck /> },
        { key: "new order", label: "New Order", icon: <MdOutlinePendingActions /> },
        { key: "in transit", label: "In Transit", icon: <FaShippingFast /> },
        { key: "manifest list", label: "Manifested", icon: <FaHourglassHalf /> },
        { key: "appointment", label: "Appointment", icon: <MdOutlineEventAvailable /> },
        { key: "delivered", label: "Delivered", icon: <FaCheckCircle /> },
        { key: "failed", label: "Failed", icon: <FaTimesCircle /> },
        { key: "zoho", label: "Zoho", icon: <SiZoho /> },
    ];

    const labelSizes = [
        { value: "A4", label: "A4" },
        { value: "3by2", label: "3×2" }
    ];

    const UserHoverPortal = () => {
        if (!hoverCardPos.id) return null;
        const data = hoverData[`user_${hoverCardPos.id}`];
        if (!data) return null;
        const { rowData: row, pickup } = data;
        const hName = pickup?.consignee_name || row.user_name || row.retailer_name || '—';
        const hPhone = pickup?.phone || '';
        const hCity = pickup?.city || '';
        const hState = pickup?.state || '';
        const hPin = pickup?.zip || '';
        const hAddr = [hCity, hState, hPin].filter(Boolean).join(', ');

        const style = {
            position: 'fixed', left: hoverCardPos.x,
            top: hoverCardPos.above ? 'auto' : hoverCardPos.y - window.scrollY,
            bottom: hoverCardPos.above ? window.innerHeight - (hoverCardPos.y - window.scrollY) : 'auto',
            zIndex: 999999, pointerEvents: 'none', width: '192px',
        };

        return createPortal(
            <div style={style}>
                {!hoverCardPos.above && <div className="ml-4 w-2.5 h-2.5 bg-indigo-500 rotate-45 -mb-1.5 relative z-10" style={{ marginTop: '2px' }} />}
                <div className="bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] rounded-xl shadow-2xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] border border-gray-200 dark:border-indigo-500/30 overflow-hidden">
                    <div className="bg-gradient-to-r from-indigo-500 to-purple-600 px-3 py-2 flex items-center gap-2">
                        <div className="w-7 h-7 rounded-full overflow-hidden bg-white/20 flex items-center justify-center flex-shrink-0">
                            {(row.profile_image || row.user_profile || row.avatar)
                                ? <img src={row.profile_image || row.user_profile || row.avatar} alt="" className="w-full h-full object-cover" />
                                : <span className="text-white font-bold text-xs">{hName.charAt(0).toUpperCase()}</span>
                            }
                        </div>
                        <div className="min-w-0">
                            <div className="text-white font-semibold text-[11px] leading-tight truncate capitalize">{hName}</div>
                            <div className="text-indigo-200 text-[10px]">#{row.user_id || '—'}</div>
                        </div>
                    </div>
                    <div className="divide-y divide-gray-100 dark:divide-indigo-500/15">
                        {hPhone && (
                            <div className="flex items-center gap-2 px-3 py-1.5">
                                <span className="text-[11px]">📞</span>
                                <div>
                                    <div className="text-[9px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">Phone</div>
                                    <div className="text-[10px] font-semibold text-gray-800 dark:text-indigo-100">{hPhone}</div>
                                </div>
                            </div>
                        )}
                        {hAddr && (
                            <div className="flex items-center gap-2 px-3 py-1.5">
                                <span className="text-[11px]">📍</span>
                                <div>
                                    <div className="text-[9px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">Origin</div>
                                    <div className="text-[10px] font-semibold text-gray-800 dark:text-indigo-100">{hAddr}</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {hoverCardPos.above && <div className="ml-4 w-2.5 h-2.5 bg-white dark:bg-[#0b0b14] border-r border-b border-gray-200 dark:border-indigo-500/30 rotate-45 -mt-1.5 relative z-10" />}
            </div>,
            document.body
        );
    };

    const AddrHoverPortal = () => {
        if (!addrHover.id) return null;
        const key = `addr_${addrHover.id}_${addrHover.type}`;
        const loc = hoverData[key];
        if (!loc) return null;
        const isPickup = addrHover.type === 'pickup';

        const style = {
            position: 'fixed', left: addrHover.x,
            top: addrHover.above ? 'auto' : addrHover.y - window.scrollY,
            bottom: addrHover.above ? window.innerHeight - (addrHover.y - window.scrollY) : 'auto',
            zIndex: 999999, pointerEvents: 'none', width: '208px',
        };

        return createPortal(
            <div style={style} className="flex flex-col">
                {!addrHover.above && (
                    <div className={`ml-3 w-2.5 h-2.5 rotate-45 -mb-1.5 relative z-10 ${isPickup ? 'bg-emerald-500' : 'bg-rose-500'}`} style={{ marginTop: '2px' }} />
                )}
                <div className="bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] rounded-xl shadow-2xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] border border-gray-200 dark:border-indigo-500/30 overflow-hidden">
                    <div className={`px-3 py-2 flex items-center gap-2 ${isPickup ? 'bg-gradient-to-r from-emerald-500 to-teal-500' : 'bg-gradient-to-r from-rose-500 to-pink-500'}`}>
                        <span className="text-white text-sm">{isPickup ? '📦' : '🎯'}</span>
                        <div>
                            <div className="text-white font-semibold text-[11px]">{isPickup ? 'Origin' : 'Destination'}</div>
                            <div className={`text-[10px] ${isPickup ? 'text-emerald-100' : 'text-rose-100'}`}>{loc.city || ''}</div>
                        </div>
                    </div>
                    <div className="divide-y divide-gray-100 dark:divide-indigo-500/15">
                        {loc.consignee_name && (
                            <div className="flex items-center gap-2 px-3 py-1.5">
                                <span className="text-[11px]">👤</span>
                                <div>
                                    <div className="text-[9px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">Consignee</div>
                                    <div className="text-[10px] font-semibold text-gray-800 dark:text-indigo-100">{loc.consignee_name}</div>
                                </div>
                            </div>
                        )}
                        <div className="flex items-start gap-2 px-3 py-1.5">
                            <span className="text-[11px] mt-0.5">📍</span>
                            <div>
                                <div className="text-[9px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">Address</div>
                                <div className="text-[10px] font-semibold text-gray-800 dark:text-indigo-100 leading-relaxed">{loc.address}</div>
                                <div className="text-[10px] text-gray-500 dark:text-indigo-300/60">{loc.city}{loc.state ? ', ' + loc.state : ''}{loc.zip ? ' - ' + loc.zip : ''}</div>
                            </div>
                        </div>
                        {loc.phone && (
                            <div className="flex items-center gap-2 px-3 py-1.5">
                                <span className="text-[11px]">📞</span>
                                <div>
                                    <div className="text-[9px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">Phone</div>
                                    <div className="text-[10px] font-semibold text-gray-800 dark:text-indigo-100">{loc.phone}</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {addrHover.above && (
                    <div className="ml-3 w-2.5 h-2.5 bg-white dark:bg-[#0b0b14] border-r border-b border-gray-200 dark:border-indigo-500/30 rotate-45 -mt-1.5 relative z-10" />
                )}
            </div>,
            document.body
        );
    };

    const WeightHoverPortal = () => {
        if (!weightHover.id) return null;
        const row = hoverData[`weight_${weightHover.id}`];
        if (!row) return null;
        let dims = [];
        try { dims = JSON.parse(row.dimensions || "[]"); } catch (e) { }
        const hasDims = dims.length > 0 || row.total_length || row.total_width || row.total_height;
        if (!hasDims) return null;

        const style = {
            position: 'fixed', left: weightHover.x - 112,
            top: weightHover.above ? 'auto' : weightHover.y - window.scrollY,
            bottom: weightHover.above ? window.innerHeight - (weightHover.y - window.scrollY) : 'auto',
            zIndex: 999999, pointerEvents: 'none', width: '224px',
        };

        return createPortal(
            <div style={style} className="flex flex-col items-center">
                {!weightHover.above && (
                    <div className="w-2.5 h-2.5 bg-violet-500 rotate-45 -mb-1.5 relative z-10" style={{ marginTop: '2px' }} />
                )}
                <div className="bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] rounded-xl shadow-2xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] border border-gray-200 dark:border-indigo-500/30 overflow-hidden w-full">
                    <div className="bg-gradient-to-r from-violet-500 to-indigo-500 px-3 py-2 flex items-center gap-2">
                        <span className="text-white text-xs">📐</span>
                        <div>
                            <div className="text-white font-semibold text-[10px]">Dimensions</div>
                            <div className="text-violet-100 text-[9px]">{row.total_boxes || 0} box{(row.total_boxes || 0) > 1 ? "es" : ""} · {row.total_weight || 0} kg</div>
                        </div>
                    </div>
                    <div className={`divide-y divide-gray-100 dark:divide-indigo-500/15 ${dims.length > 5 ? "max-h-48 overflow-y-auto" : ""}`}>
                        {dims.length > 0 ? dims.map((d, i) => (
                            <div key={i} className="flex items-center gap-2 px-3 py-1.5">
                                <span className="text-[10px]">📦</span>
                                <div>
                                    <div className="text-[8px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">Box {i + 1}{d.box_count > 1 ? ` (×${d.box_count})` : ""}</div>
                                    <div className="text-[9px] font-semibold text-gray-800 dark:text-indigo-100">{d.length || 0} × {d.width || 0} × {d.height || 0} cm</div>
                                </div>
                            </div>
                        )) : (
                            <div className="flex items-center gap-2 px-3 py-1.5">
                                <span className="text-[10px]">↔️</span>
                                <div>
                                    <div className="text-[8px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">L × W × H</div>
                                    <div className="text-[9px] font-semibold text-gray-800 dark:text-indigo-100">{row.total_length || 0} × {row.total_width || 0} × {row.total_height || 0} cm</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {weightHover.above && (
                    <div className="w-2.5 h-2.5 bg-white dark:bg-[#0b0b14] border-r border-b border-gray-200 dark:border-indigo-500/30 rotate-45 -mt-1.5 relative z-10" />
                )}
            </div>,
            document.body
        );
    };

    const TypeHoverPortal = () => {
        if (!typeHover.id) return null;
        const style = {
            position: 'fixed', left: typeHover.x,
            top: typeHover.above ? 'auto' : typeHover.y - window.scrollY,
            bottom: typeHover.above ? window.innerHeight - (typeHover.y - window.scrollY) : 'auto',
            zIndex: 999999, pointerEvents: 'none', transform: 'translateX(-50%)',
        };
        return createPortal(
            <div style={style} className="flex flex-col items-center">
                {!typeHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mb-1"></div>}
                <div className="bg-gray-900 text-white text-[11px] font-medium px-3 py-1.5 rounded-lg shadow-xl whitespace-nowrap">{typeHover.label}</div>
                {typeHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mt-1"></div>}
            </div>,
            document.body
        );
    };

    const StatusHoverPortal = () => {
        if (!statusHover.id) return null;
        const style = {
            position: 'fixed', left: statusHover.x,
            top: statusHover.above ? 'auto' : statusHover.y - window.scrollY,
            bottom: statusHover.above ? window.innerHeight - (statusHover.y - window.scrollY) : 'auto',
            zIndex: 999999, pointerEvents: 'none', transform: 'translateX(-50%)',
        };
        return createPortal(
            <div style={style} className="flex flex-col items-center">
                {!statusHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mb-1"></div>}
                <div className="bg-gray-900 text-white text-[11px] font-medium px-3 py-1.5 rounded-lg shadow-xl whitespace-nowrap">{statusHover.label}</div>
                {statusHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mt-1"></div>}
            </div>,
            document.body
        );
    };

    const ProductHoverPortal = () => {
        if (!productHover.id) return null;
        const row = hoverData[`product_${productHover.id}`];
        if (!row) return null;

        let shipmentDetails = [];
        try { shipmentDetails = JSON.parse(row.shipment_details || "[]"); } catch (e) { }
        let invoices = [];
        try { invoices = JSON.parse(row.invoices || "[]"); } catch (e) { }

        const style = {
            position: 'fixed', left: productHover.x,
            top: productHover.above ? 'auto' : productHover.y - window.scrollY,
            bottom: productHover.above ? window.innerHeight - (productHover.y - window.scrollY) : 'auto',
            zIndex: 999999, pointerEvents: 'none', width: '240px',
        };

        return createPortal(
            <div style={style} className="flex flex-col">
                {!productHover.above && (
                    <div className="ml-4 w-2.5 h-2.5 bg-amber-500 rotate-45 -mb-1.5 relative z-10" style={{ marginTop: '2px' }} />
                )}
                <div className="bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] rounded-xl shadow-2xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] border border-gray-200 dark:border-indigo-500/30 overflow-hidden">
                    <div className="bg-gradient-to-r from-amber-500 to-orange-500 px-3 py-2 flex items-center gap-2">
                        <span className="text-white text-sm">🛒</span>
                        <div>
                            <div className="text-white font-semibold text-[11px]">Product Details</div>
                            <div className="text-amber-100 text-[9px]">{shipmentDetails.length || 0} item{(shipmentDetails.length || 0) > 1 ? "s" : ""}</div>
                        </div>
                    </div>
                    <div className={`divide-y divide-gray-100 dark:divide-indigo-500/15 ${shipmentDetails.length > 4 ? "max-h-48 overflow-y-auto" : ""}`}>
                        {shipmentDetails.length > 0 ? shipmentDetails.map((d, i) => (
                            <div key={i} className="flex items-start gap-2 px-3 py-1.5">
                                <span className="text-[11px] mt-0.5">📦</span>
                                <div>
                                    <div className="text-[9px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">Item {i + 1}</div>
                                    <div className="text-[10px] font-semibold text-gray-800 dark:text-indigo-100 leading-relaxed">{d.description || '—'}</div>
                                    {(d.quantity || d.qty) && (
                                        <div className="text-[9px] text-gray-500 dark:text-indigo-300/60">Qty: {d.quantity || d.qty}</div>
                                    )}
                                </div>
                            </div>
                        )) : (
                            <div className="flex items-center gap-2 px-3 py-1.5">
                                <span className="text-[11px]">📦</span>
                                <div className="text-[10px] font-semibold text-gray-800 dark:text-indigo-100">No product details available</div>
                            </div>
                        )}
                        <div className="flex items-center gap-2 px-3 py-1.5">
                            <span className="text-[11px]">🧾</span>
                            <div>
                                <div className="text-[9px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">Invoices</div>
                                <div className="text-[10px] font-semibold text-gray-800 dark:text-indigo-100">{invoices.length || 0} invoice{invoices.length !== 1 ? "s" : ""}</div>
                            </div>
                        </div>
                        <div className="flex items-center gap-2 px-3 py-1.5">
                            <span className="text-[11px]">₹</span>
                            <div>
                                <div className="text-[9px] text-gray-400 dark:text-indigo-300/60 uppercase tracking-wide">Amount</div>
                                <div className="text-[10px] font-semibold text-gray-800 dark:text-indigo-100">₹{parseFloat(row.debit_amount || 0).toFixed(2)}</div>
                            </div>
                        </div>
                    </div>
                </div>
                {productHover.above && (
                    <div className="ml-4 w-2.5 h-2.5 bg-white dark:bg-[#0b0b14] border-r border-b border-gray-200 dark:border-indigo-500/30 rotate-45 -mt-1.5 relative z-10" />
                )}
            </div>,
            document.body
        );
    };

    const ActionDropdownPortal = () => {
        if (!showActionDropdown) return null;
        const row = filteredData.find(r => r.order_id === showActionDropdown);
        if (!row) return null;

        const statusLower = row.status?.toLowerCase() || "";
        const isManifestPending = ["manifest pending", "lrn pending"].includes(statusLower);
        const isPending = statusLower.includes("pending") && !isManifestPending;
        const isFailed = statusLower.includes("failed");
        const isManifested = statusLower.includes("manifested") || statusLower === "manifest";
        const isInTransit = statusLower.includes("in_transit") || statusLower.includes("in transit") || ['left_origin', 'reach_destination', 'out_for_delivery'].some(s => statusLower.includes(s));
        const isDelivered = statusLower.includes("delivered") || statusLower.includes("completed");
        const isCancelled = statusLower.includes("cancel") || statusLower.includes("rto");
        const canBookAppointment = (isManifested || isInTransit) && !isDelivered && !isPending && !isManifestPending && !isFailed && !isCancelled;
        const hasWaybill = !!(row.waybill || row.lrn);

        const dropdownWidth = 224;
        const gap = 6;
        const viewportHeight = window.innerHeight;
        const viewportWidth = window.innerWidth;

        const btnBottom = actionDropdownPos.bottom || actionDropdownPos.y || 0;
        const btnTop = actionDropdownPos.top !== undefined ? actionDropdownPos.top : Math.max(0, btnBottom - 28);
        const btnRight = actionDropdownPos.right || actionDropdownPos.x || 0;

        const spaceBelow = viewportHeight - btnBottom;
        const spaceAbove = btnTop;

        // Open upward if space below is insufficient (e.g. last rows) and there is more space above
        const openUpward = spaceBelow < 260 && spaceAbove > spaceBelow;

        let left = btnRight - dropdownWidth;
        if (left < 10) left = 10;
        if (left + dropdownWidth > viewportWidth - 10) left = viewportWidth - dropdownWidth - 10;

        const style = {
            position: 'fixed',
            left: `${left}px`,
            zIndex: 999999,
            width: `${dropdownWidth}px`,
            overflowY: 'auto',
        };

        if (openUpward) {
            style.bottom = `${viewportHeight - btnTop + gap}px`;
            style.maxHeight = `${Math.max(160, Math.min(380, spaceAbove - gap - 12))}px`;
        } else {
            style.top = `${btnBottom + gap}px`;
            style.maxHeight = `${Math.max(160, Math.min(380, spaceBelow - gap - 12))}px`;
        }

        return createPortal(
            <div
                style={style}
                className="action-dropdown-wrapper p-1.5 bg-white/95 dark:bg-[#0c0e1a]/95 backdrop-blur-xl border border-slate-200/90 dark:border-indigo-500/30 rounded-2xl shadow-[0_20px_50px_-10px_rgba(15,23,42,0.25),0_4px_16px_-4px_rgba(15,23,42,0.1)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.8),0_0_24px_rgba(99,102,241,0.25)] ring-1 ring-black/5 dark:ring-indigo-500/20 text-left custom-scrollbar"
            >
                {/* Mini Header */}
                <div className="px-2.5 py-1.5 mb-1 flex items-center justify-between border-b border-slate-100 dark:border-white/[0.08]">
                    <span className="text-[10px] font-bold uppercase tracking-wider text-slate-400 dark:text-slate-400">Actions</span>
                    <span className="text-[10px] font-mono font-medium text-slate-400 dark:text-indigo-300 truncate max-w-[110px]">
                        #{row.order_id}
                    </span>
                </div>

                {isManifestPending && (
                    <button
                        type="button"
                        onClick={() => { handleRefreshStatus(row); setShowActionDropdown(null); }}
                        className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-semibold text-blue-600 dark:text-blue-300 hover:bg-blue-50/80 dark:hover:bg-blue-950/30 active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                    >
                        <div className="flex items-center gap-2.5">
                            <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-blue-50 text-blue-600 dark:bg-blue-950/70 dark:text-blue-400 border border-blue-100 dark:border-blue-900/50 group-hover:bg-blue-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                                <HiOutlineArrowPath className="w-4 h-4 group-hover:rotate-180 transition-transform duration-300" />
                            </span>
                            <span>Refresh Status</span>
                        </div>
                        <HiChevronRight className="w-3.5 h-3.5 text-blue-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                    </button>
                )}

                {!isManifestPending && (
                    <div className="space-y-0.5">
                        {/* View Shipment */}
                        <button
                            type="button"
                            onClick={() => { handleViewClick(row); setShowActionDropdown(null); }}
                            className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                        >
                            <div className="flex items-center gap-2.5">
                                <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-indigo-50 text-indigo-600 dark:bg-indigo-950/70 dark:text-indigo-400 border border-indigo-100 dark:border-indigo-900/50 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                                    <HiOutlineEye className="w-4 h-4" />
                                </span>
                                <span>View Shipment</span>
                            </div>
                            <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                        </button>

                        {/* Clone Order */}
                        <button
                            type="button"
                            onClick={() => { handleCloneOrder(row); setShowActionDropdown(null); }}
                            className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                        >
                            <div className="flex items-center gap-2.5">
                                <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-sky-50 text-sky-600 dark:bg-sky-950/70 dark:text-sky-400 border border-sky-100 dark:border-sky-900/50 group-hover:bg-sky-500 group-hover:text-white transition-all duration-150 shadow-2xs">
                                    <HiOutlineDocumentDuplicate className="w-4 h-4" />
                                </span>
                                <span>Clone Order</span>
                            </div>
                            <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                        </button>

                        {/* Download POD (if delivered) */}
                        {isDelivered && (
                            <button
                                type="button"
                                onClick={() => { handleDownloadPOD(row); setShowActionDropdown(null); }}
                                className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                            >
                                <div className="flex items-center gap-2.5">
                                    <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-teal-50 text-teal-600 dark:bg-teal-950/70 dark:text-teal-400 border border-teal-100 dark:border-teal-900/50 group-hover:bg-teal-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                                        <HiOutlineDocumentText className="w-4 h-4" />
                                    </span>
                                    <span>Download POD</span>
                                </div>
                                <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                            </button>
                        )}

                        {/* Book Appointment */}
                        {canBookAppointment && (
                            <button
                                type="button"
                                onClick={() => { handleBookAppointment(row); setShowActionDropdown(null); }}
                                className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                            >
                                <div className="flex items-center gap-2.5">
                                    <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-amber-50 text-amber-600 dark:bg-amber-950/70 dark:text-amber-400 border border-amber-100 dark:border-amber-900/50 group-hover:bg-amber-500 group-hover:text-white transition-all duration-150 shadow-2xs">
                                        <HiOutlineCalendarDays className="w-4 h-4" />
                                    </span>
                                    <span>Book Appointment</span>
                                </div>
                                <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                            </button>
                        )}

                        {/* Failure Reason */}
                        {isFailed && (
                            <button
                                type="button"
                                onClick={() => { handleShowFailedReason(row); setShowActionDropdown(null); }}
                                className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-amber-700 dark:text-amber-300 hover:bg-amber-50/80 dark:hover:bg-amber-950/30 active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                            >
                                <div className="flex items-center gap-2.5">
                                    <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-amber-50 text-amber-600 dark:bg-amber-950/70 dark:text-amber-400 border border-amber-100 dark:border-amber-900/50 group-hover:bg-amber-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                                        <HiOutlineExclamationTriangle className="w-4 h-4" />
                                    </span>
                                    <span>Failure Reason</span>
                                </div>
                                <HiChevronRight className="w-3.5 h-3.5 text-amber-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                            </button>
                        )}

                        {/* Pending Orders Actions: Ship Now & Cancel */}
                        {isPending && (
                            <>
                                <button
                                    type="button"
                                    onClick={() => { hanldeShipNow(row); setShowActionDropdown(null); }}
                                    className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-semibold text-emerald-700 dark:text-emerald-300 hover:bg-emerald-50/80 dark:hover:bg-emerald-950/30 active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                                >
                                    <div className="flex items-center gap-2.5">
                                        <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-gradient-to-tr from-emerald-500 to-teal-500 text-white shadow-sm shadow-emerald-500/30 group-hover:scale-105 transition-all duration-150">
                                            <HiOutlineRocketLaunch className="w-4 h-4" />
                                        </span>
                                        <span>Ship Now</span>
                                    </div>
                                    <span className="px-1.5 py-0.5 text-[9px] font-bold tracking-wider uppercase rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
                                        Fast
                                    </span>
                                </button>

                                <button
                                    type="button"
                                    onClick={() => { handleCancelOrder(row.order_id); setShowActionDropdown(null); }}
                                    className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-rose-600 dark:text-rose-400 hover:bg-rose-50/80 dark:hover:bg-rose-950/30 active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                                >
                                    <div className="flex items-center gap-2.5">
                                        <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-rose-50 text-rose-600 dark:bg-rose-950/70 dark:text-rose-400 border border-rose-100 dark:border-rose-900/50 group-hover:bg-rose-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                                            <HiOutlineXCircle className="w-4 h-4" />
                                        </span>
                                        <span>Cancel Order</span>
                                    </div>
                                    <HiChevronRight className="w-3.5 h-3.5 text-rose-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                                </button>
                            </>
                        )}

                        {/* Labels & Waybill for Non-Pending/Shipped orders */}
                        {!isPending && !isFailed && !isDelivered && (
                            <div className="pt-1 mt-1 border-t border-slate-100 dark:border-white/[0.08] space-y-0.5">
                                {labelSizes.map((s) => (
                                    <button
                                        key={s.value}
                                        type="button"
                                        onClick={() => { handlePrintLabel(row.order_id, s.value); setShowActionDropdown(null); }}
                                        className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                                    >
                                        <div className="flex items-center gap-2.5">
                                            <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-violet-50 text-violet-600 dark:bg-violet-950/70 dark:text-violet-400 border border-violet-100 dark:border-violet-900/50 group-hover:bg-violet-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                                                <HiOutlinePrinter className="w-4 h-4" />
                                            </span>
                                            <span>Label ({s.label})</span>
                                        </div>
                                        <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                                    </button>
                                ))}

                                {hasWaybill && (
                                    <button
                                        type="button"
                                        onClick={() => { handleDownloadWaybill(row.order_id); setShowActionDropdown(null); }}
                                        className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                                    >
                                        <div className="flex items-center gap-2.5">
                                            <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-cyan-50 text-cyan-600 dark:bg-cyan-950/70 dark:text-cyan-400 border border-cyan-100 dark:border-cyan-900/50 group-hover:bg-cyan-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                                                <HiOutlineArrowDownTray className="w-4 h-4" />
                                            </span>
                                            <span>Download Waybill</span>
                                        </div>
                                        <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                                    </button>
                                )}
                            </div>
                        )}

                        {/* Labels & Waybill for Delivered orders */}
                        {isDelivered && (
                            <div className="pt-1 mt-1 border-t border-slate-100 dark:border-white/[0.08] space-y-0.5">
                                {labelSizes.map((s) => (
                                    <button
                                        key={s.value}
                                        type="button"
                                        onClick={() => { handlePrintLabel(row.order_id, s.value); setShowActionDropdown(null); }}
                                        className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                                    >
                                        <div className="flex items-center gap-2.5">
                                            <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-violet-50 text-violet-600 dark:bg-violet-950/70 dark:text-violet-400 border border-violet-100 dark:border-violet-900/50 group-hover:bg-violet-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                                                <HiOutlinePrinter className="w-4 h-4" />
                                            </span>
                                            <span>Label ({s.label})</span>
                                        </div>
                                        <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                                    </button>
                                ))}
                                {hasWaybill && (
                                    <button
                                        type="button"
                                        onClick={() => { handleDownloadWaybill(row.order_id); setShowActionDropdown(null); }}
                                        className="group w-full flex items-center justify-between px-2.5 py-1.5 rounded-xl text-xs font-medium text-slate-700 dark:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-white/[0.08] active:scale-[0.98] transition-all duration-150 text-left cursor-pointer"
                                    >
                                        <div className="flex items-center gap-2.5">
                                            <span className="w-7 h-7 rounded-lg flex items-center justify-center bg-cyan-50 text-cyan-600 dark:bg-cyan-950/70 dark:text-cyan-400 border border-cyan-100 dark:border-cyan-900/50 group-hover:bg-cyan-600 group-hover:text-white transition-all duration-150 shadow-2xs">
                                                <HiOutlineArrowDownTray className="w-4 h-4" />
                                            </span>
                                            <span>Download Waybill</span>
                                        </div>
                                        <HiChevronRight className="w-3.5 h-3.5 text-slate-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-150" />
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>,
            document.body
        );
    };
    const navigate = useNavigate();
    const glass =
        "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
        "border border-white/60 dark:border-white/10 " +
        "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";

    return (
        <>
            <ToastContainer
                containerId={TOAST_CONTAINER_ID}
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'}`}>
                <NavBar />
                <div className="flex flex-1 overflow-hidden">
                    <div
                        className={`${isToggleSidebar ? "md:w-64" : "md:w-20"} w-0 m-0 md:m-3 md:rounded-3xl ${glass} overflow-visible md:overflow-hidden transition-all duration-300 ease-in-out flex-shrink-0`}
                    // onClick={handlePageClick}
                    >
                        <Sidebar />
                    </div>

                    <FullPageLoader isLoading={isPageLoading} message="Processing..." />

                    <UserHoverPortal />
                    <AddrHoverPortal />
                    <WeightHoverPortal />
                    <TypeHoverPortal />
                    <StatusHoverPortal />
                    <ProductHoverPortal />
                    <ActionDropdownPortal />

                    <div className="flex-1 bg-gray-100 dark:bg-black p-3 md:p-3 overflow-y-auto custom-scrollbar min-w-0">
                        {/* ================= MOBILE HEADER (only < md) ================= */}
                        <div className="md:hidden mb-3">
                            <div className="flex items-center justify-between mb-3">
                                <h1 className="text-lg font-bold text-gray-800 dark:text-white">
                                    All B2B Shipments
                                </h1>
                                <span className="text-[10px] font-semibold text-indigo-600 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-500/15 px-2.5 py-1 rounded-full border border-indigo-100 dark:border-indigo-500/30">
                                    {filteredData.length} orders
                                </span>
                            </div>

                            {/* Search bar full width */}
                            <div className="relative w-full mb-3">
                                <CgSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-indigo-300/70" size={18} />
                                <input
                                    type="text"
                                    placeholder="Search Order ID, Waybill..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="w-full pl-11 pr-4 py-2.5 bg-white dark:bg-[#141425] border border-gray-200 dark:border-indigo-500/30 rounded-2xl focus:border-indigo-500 dark:focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/20 outline-none text-[13px] dark:text-white dark:placeholder-indigo-300/50 shadow-sm transition-all"
                                />
                            </div>

                            {/* Three action buttons grid */}
                            <div className="grid grid-cols-3 gap-2">
                                <button
                                    onClick={() => navigate("/b2b/shipment/pickuprequest")}
                                    className="bg-gradient-to-r flex gap-2 from-rose-500 to-red-600 hover:from-rose-400 hover:to-red-500 text-white px-2 py-2 rounded-2xl  items-center justify-center  font-semibold text-[11px] shadow-lg shadow-red-500/25 active:scale-[0.97] transition-transform"
                                >
                                    <FaTruck size={14} />
                                    <span>Pickup Request</span>
                                </button>
                                <button
                                    onClick={() => setIsAddShipmentOpen(true)}
                                    className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-500 hover:to-indigo-500 text-white px-2 py-2  rounded-2xl flex  items-center justify-center gap-2 font-semibold text-[11px] shadow-lg shadow-indigo-500/25 active:scale-[0.97] transition-transform"
                                >
                                    <FaPlus size={14} />
                                    <span>Add Shipment</span>
                                </button>
                                <button
                                    onClick={UploadBulkViewClick}
                                    className="bg-white dark:bg-[#141425] text-gray-700 dark:text-indigo-200 border border-gray-200 dark:border-indigo-500/30 hover:bg-gray-50 dark:hover:bg-indigo-500/10 px-2 py-2 rounded-2xl flex  items-center justify-center gap-2 font-semibold text-[11px] shadow-sm active:scale-[0.97] transition-transform"
                                >
                                    <FaBox size={14} />
                                    <span>Upload bulk </span>
                                </button>
                            </div>
                        </div>

                        {/* ================= DESKTOP HEADER (md and up) ================= */}
                        <div className='hidden md:flex justify-between items-center mb-2'>
                            <h1 className="text-xl md:text-xl font-bold text-gray-800 dark:text-white">
                                All B2B Shipments
                            </h1>
                            <div className="flex items-center gap-3">
                                <button
                                    onClick={() => navigate("/b2b/shipment/pickuprequest")}
                                    className="bg-red-600 dark:bg-gradient-to-r dark:from-rose-600 dark:to-red-600 dark:hover:from-rose-500 dark:hover:to-red-500 dark:shadow-lg dark:shadow-red-900/40 text-white px-2 py-1 rounded-lg shadow-md hover:shadow-lg transition-all text-sm md:text-[12px] font-medium flex items-center gap-2"
                                >
                                    Pickup Request
                                </button>
                                <div className="flex items-center gap-1">
                                    <button
                                        onClick={() => setIsAddShipmentOpen(true)}
                                        className="bg-blue-700 dark:bg-gradient-to-r dark:from-indigo-600 dark:to-purple-600 dark:hover:from-indigo-500 dark:hover:to-purple-500 dark:shadow-lg dark:shadow-indigo-900/50 text-white px-2 py-1 rounded-lg shadow-md hover:shadow-lg transition-all text-sm md:text-[12px] font-medium flex items-center gap-2"
                                    >
                                        <FaPlus className="text-white" size={12} />
                                        Add Shipment
                                    </button>
                                </div>
                                <button
                                    onClick={UploadBulkViewClick}
                                    className="bg-gray-100 dark:bg-black text-gray-700 dark:text-indigo-200 px-2 py-1 rounded-lg shadow-md hover:shadow-lg hover:bg-gray-200 dark:hover:bg-indigo-500/10 border border-gray-300 dark:border-indigo-500/40 transition-all text-sm md:text-[12px] font-medium flex items-center gap-2"
                                >
                                    <FaBox className="text-gray-700 dark:text-indigo-300" size={12} />
                                    Upload Bulk
                                </button>

                                <div className="relative w-full md:w-80 lg:w-80">
                                    <CgSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-indigo-300/70" size={18} />
                                    <input
                                        type="text"
                                        placeholder="Search by Order ID, Waybill..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        className="w-full pl-10 pr-4 py-1.5 md:py-1.5 bg-white dark:bg-[#1a1a2e] border border-gray-300 dark:border-indigo-400/50 rounded-lg focus:border-blue-500 dark:focus:border-indigo-400 dark:focus:ring-2 dark:focus:ring-indigo-500/40 outline-none text-sm dark:text-white dark:placeholder-indigo-300/50 transition-all"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="flex flex-col md:flex-row md:items-end gap-3 md:gap-4 mb-2">
                            <div
                                className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide flex-1"
                                style={{ msOverflowStyle: 'none', scrollbarWidth: 'none' }}
                            >
                                {tabs.map(tab => {
                                    const count = getTabCount(tab.key);
                                    const isActive = activeTab === tab.key;
                                    return (
                                        <button
                                            key={tab.key}
                                            onClick={() => setActiveTab(tab.key)}
                                            className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-xl transition-all whitespace-nowrap flex-shrink-0 cursor-pointer
                                                ${isActive
                                                    ? "bg-gradient-to-r from-purple-600 to-indigo-600 text-white shadow-md shadow-purple-500/25"
                                                    : "bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 text-slate-600 dark:text-slate-300 hover:border-purple-300 hover:bg-slate-50 dark:hover:bg-slate-800/60"
                                                }`}
                                        >
                                            <span className="hidden sm:inline">{tab.icon}</span>
                                            <span className='text-[12px]'>{tab.label}</span>
                                            <span className={`ml-1 px-1.5 py-0.5 text-[11px] font-bold rounded-full ${isActive ? 'bg-white/25 text-white' : 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300'}`}>
                                                {count}
                                            </span>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                        {!isMobileCardView && (
                            <div className="overflow-x-auto pb-4" style={{ overflow: 'visible' }}>
                                <table className="w-full table-fixed border-separate border-spacing-y-1.5 text-xs">
                                    <colgroup>
                                        <col style={{ width: '3.5%' }} />
                                        <col style={{ width: '15%' }} />
                                        {isAdmin && <col style={{ width: '12%' }} />}
                                        <col style={{ width: '9%' }} />
                                        <col style={{ width: '22%' }} />
                                        <col style={{ width: '12%' }} />
                                        <col style={{ width: '6.5%' }} />
                                        <col style={{ width: '7%' }} />
                                        <col style={{ width: '7%' }} />
                                        <col style={{ width: '6%' }} />
                                    </colgroup>
                                    <thead>
                                        <tr className="text-slate-600 dark:text-slate-300">
                                            <th className="py-2 px-3 w-8 text-center rounded-l-xl border-y border-l border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">
                                                <input type="checkbox" className="w-3.5 h-3.5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer accent-indigo-600" />
                                            </th>
                                            <th className="py-2 px-3 text-left text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">OID &amp; AWB</th>
                                            {isAdmin && <th className="py-2 px-3 text-left text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">USER</th>}
                                            <th className="py-2 px-3 text-left text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">DATE</th>
                                            <th className="py-2 px-3 text-left text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">PICKUP &amp; DELIVERY ADDRESS</th>
                                            <th className="py-2 px-3 text-left text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">PRODUCT DETAILS</th>
                                            <th className="py-2 px-3 text-center text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">FREIGHT</th>
                                            <th className="py-2 px-3 text-center text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">BOX COUNT</th>
                                            <th className="py-2 px-3 text-center text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap border-y border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">STATUS</th>
                                            <th className="py-2 px-3 text-center text-[11px] font-bold text-slate-600 dark:text-slate-300 uppercase tracking-wider whitespace-nowrap rounded-r-xl border-y border-r border-slate-200/90 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/90 shadow-2xs">ACTIONS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedData.map((row, index) => {
                                            const pickup = row.pickup_location ? JSON.parse(row.pickup_location || '{}') : {};
                                            const dropoff = row.dropoff_location ? JSON.parse(row.dropoff_location || '{}') : {};
                                            const statusLower = row.status?.toLowerCase() || "";
                                            const isManifestPending = ["manifest pending", "lrn pending"].includes(statusLower);
                                            const isPending = statusLower.includes("pending") && !isManifestPending;
                                            const isFailed = statusLower.includes("failed");
                                            const isInTransit = statusLower.includes("in_transit");
                                            const isDelivered = statusLower.includes("delivered") || statusLower.includes("completed");
                                            const hasWaybill = !!(row.waybill || row.lrn);
                                            const isTrackDisabled = (isPending || isManifestPending) || !hasWaybill;

                                            let invoicesCount = 0;
                                            try { invoicesCount = JSON.parse(row.invoices || "[]").length; } catch (e) { }
                                            const description = row.shipment_details ? (JSON.parse(row.shipment_details || '[]')[0]?.description || '—') : '—';

                                            const shipmentType = (row.shipment_type || "LITE").toUpperCase();
                                            const shipmentTypeShortMap = { LITE: "LT", HEAVY: "HV", DENSE: "DN" };

                                            const fullStatus = row.status || "—";
                                            const statusCfg = getB2BStatusBadgeConfig(fullStatus);
                                            const readableStatus = fullStatus.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase());

                                            const isRowRefreshing = refreshingOrderId === row.order_id;
                                            const cellBg = isRowRefreshing
                                                ? "bg-indigo-50/60 dark:bg-indigo-950/40"
                                                : "bg-white dark:bg-[#111827] group-hover:bg-slate-50/70 dark:group-hover:bg-slate-800/60";
                                            const cellBorder = isRowRefreshing
                                                ? "border-indigo-300 dark:border-indigo-700"
                                                : "border-gray-200/75 dark:border-gray-800 group-hover:border-gray-300 dark:group-hover:border-gray-700";

                                            return (
                                                <tr key={row.id}
                                                    className={`group row-animate transition-all duration-200 shadow-xs hover:shadow-md hover:shadow-gray-200/70 dark:hover:shadow-black/50 hover:-translate-y-0.5 ${
                                                        isRowRefreshing ? 'relative ring-2 ring-indigo-500/50 bg-indigo-50/40 dark:bg-indigo-950/30' : ''
                                                    }`}
                                                    style={{ animationDelay: `${index * 20}ms` }}
                                                >
                                                    {/* Checkbox */}
                                                    <td className={`py-1.5 px-3 text-center align-middle rounded-l-2xl border-y border-l ${cellBorder} ${cellBg} transition-all`}>
                                                        <input type="checkbox" className="w-3.5 h-3.5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer accent-indigo-600" />
                                                    </td>

                                                    {/* OID & AWB */}
                                                    <td className={`py-1.5 px-3 align-middle border-y ${cellBorder} ${cellBg} transition-all`}>
                                                        <div className="flex flex-col gap-0.5">
                                                            <div className="flex items-center gap-1.5">
                                                                <span
                                                                    onClick={() => copyToClipboard(row.order_id, "Order ID")}
                                                                    title="Click to copy Order ID"
                                                                    className="font-semibold text-[13px] text-blue-600 dark:text-blue-400 underline decoration-blue-200 hover:decoration-blue-500 hover:text-blue-700 cursor-pointer transition-colors tracking-tight select-none"
                                                                >
                                                                    {row.order_id}
                                                                </span>
                                                                <TbRoute
                                                                    size={15}
                                                                    className="cursor-pointer text-sky-500 hover:text-blue-600 hover:scale-125 transition-all shrink-0"
                                                                    title="Trace shipment"
                                                                    onClick={() => handleOpenTrackingPopup(row)}
                                                                />
                                                            </div>
                                                            {isRowRefreshing && (
                                                                <div className="flex items-center gap-1.5 text-[10px] font-semibold text-indigo-600 dark:text-indigo-400 mt-0.5 animate-pulse">
                                                                    <svg className="animate-spin h-2.5 w-2.5 text-indigo-600 dark:text-indigo-400 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                                                                    </svg>
                                                                    <span>Updating shipment...</span>
                                                                </div>
                                                            )}
                                                            {hasWaybill && (
                                                                <div
                                                                    onClick={() => copyToClipboard(row.waybill || row.lrn, "AWB")}
                                                                    title="Click to copy AWB"
                                                                    className="text-[10px] font-mono text-gray-500 dark:text-gray-400 hover:text-blue-600 cursor-pointer inline-flex items-center gap-1 bg-gray-50 dark:bg-gray-800/80 hover:bg-gray-100 px-1.5 py-0.2 rounded border border-gray-200/80 dark:border-gray-700 w-fit transition-colors"
                                                                >
                                                                    <span className="font-normal text-gray-400">AWB:</span>
                                                                    <span className="font-medium text-gray-700 dark:text-gray-300">{row.waybill || row.lrn}</span>
                                                                </div>
                                                            )}
                                                            {hasWaybill && (
                                                                <div className="flex items-center gap-2 mt-0.5">
                                                                    <div className="text-[10px] text-gray-400 dark:text-indigo-300/60 opacity-80 flex items-center">
                                                                        {row.courier_partner ? (
                                                                            <>
                                                                                {row.courier_partner?.toLowerCase() === "delhivery" && (
                                                                                    <div className="flex items-center">
                                                                                        {isDarkMode
                                                                                            ? <img src="/assets/images/DELHIVERYWhite.png" alt="Delhivery" className="h-1.5 w-auto object-contain" />
                                                                                            : <img src="/assets/images/Delhivery.png" alt="Delhivery" className="h-1.5 w-auto object-contain" />
                                                                                        }
                                                                                    </div>
                                                                                )}
                                                                                {row.courier_partner?.toLowerCase() === "ecom" && (
                                                                                    <div className="flex items-center rounded-full">
                                                                                        {isDarkMode
                                                                                            ? <img src="/assets/images/logoecom.svg" alt="Ecom Express" className="h-1.5 w-auto object-contain" />
                                                                                            : <img src="/assets/images/ecom-express-logo.png" alt="Ecom Express" className="h-14 w-auto object-contain" />
                                                                                        }
                                                                                    </div>
                                                                                )}
                                                                                {row.courier_partner?.toLowerCase() === "ekart" && (
                                                                                    <div className="flex items-center">
                                                                                        <img src="/assets/images/ekart.png" alt="Ekart" className="h-9 w-auto object-contain" />
                                                                                    </div>
                                                                                )}
                                                                                {row.courier_partner?.toLowerCase() === "xpressbees" && (
                                                                                    <div className="flex items-center">
                                                                                        <img src="/assets/images/xpressbess.png" alt="xpressbess" className="h-[10px] w-auto object-contain" />
                                                                                    </div>
                                                                                )}
                                                                                {row.courier_partner?.toLowerCase() === "bluedart" && (
                                                                                    <div className="flex items-center">
                                                                                        <img src="/assets/images/bluedart.png" alt="bluedart" className="h-[10px] w-auto object-contain" />
                                                                                    </div>
                                                                                )}
                                                                                {row.courier_partner?.toLowerCase().includes("gati") && (
                                                                                    <div className="flex items-center">
                                                                                        <img src="/assets/images/gati.png?v=4" alt="Gati" className="h-[13px] w-auto max-w-[55px] object-contain rounded-xs" />
                                                                                    </div>
                                                                                )}
                                                                                {row.courier_partner?.toLowerCase().replace(/[^a-z]/g, '').includes("pickupxpress") && (
                                                                                    <div className="flex items-center">
                                                                                        <img src="/assets/images/logo1.png" alt="PickupXpress" className="w-12 object-contain" />
                                                                                    </div>
                                                                                )}
                                                                                {!["delhivery", "ecom", "ekart", "xpressbees", "bluedart", "gati"].some(c => row.courier_partner?.toLowerCase().includes(c)) &&
                                                                                    !row.courier_partner?.toLowerCase().replace(/[^a-z]/g, '').includes("pickupxpress") && (
                                                                                        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-medium bg-gray-100 dark:bg-indigo-500/15 text-gray-700 dark:text-indigo-200 border border-gray-200 dark:border-indigo-400/40">
                                                                                            {row.courier_partner}
                                                                                        </span>
                                                                                    )}
                                                                            </>
                                                                        ) : (
                                                                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[9px] font-medium bg-gray-100 dark:bg-indigo-500/15 text-gray-500 dark:text-indigo-300/70 border border-gray-200 dark:border-indigo-400/40">
                                                                                Unavailable
                                                                            </span>
                                                                        )}
                                                                    </div>

                                                                    {/* Appointment icon next to courier partner */}
                                                                    <button
                                                                        type="button"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleBookAppointment(row);
                                                                        }}
                                                                        title={row.appointment_date ? `Appointment: ${row.appointment_date} (${row.appointment_slot || 'Slot Set'})` : "Schedule / View Appointment"}
                                                                        className="group/appt inline-flex items-center justify-center p-0.5 rounded text-purple-600 dark:text-purple-400 hover:text-purple-800 dark:hover:text-purple-200 hover:bg-purple-100/70 dark:hover:bg-purple-500/20 border border-purple-200/90 dark:border-purple-500/30 transition-all cursor-pointer shadow-2xs active:scale-95"
                                                                    >
                                                                        <MdOutlineEventAvailable size={13} className="group-hover/appt:scale-110 transition-transform" />
                                                                    </button>
                                                                </div>
                                                            )}
                                                            {row.appointment_date && (
                                                                <div className="flex items-center gap-1 text-[9px] text-purple-600 dark:text-purple-300 font-medium mt-0.5">
                                                                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-purple-500 animate-pulse" />
                                                                    <span>{row.appointment_date} {row.appointment_slot ? `• ${row.appointment_slot}` : ''}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>

                                                    {/* User */}
                                                    {isAdmin && (
                                                        <td className={`py-1.5 px-3 align-middle border-y ${cellBorder} ${cellBg} transition-all`}>
                                                            <div
                                                                className="inline-block w-full cursor-pointer"
                                                                onMouseEnter={(e) => handleUserMouseEnter(e, row.id, row, pickup)}
                                                                onMouseLeave={handleUserMouseLeave}
                                                            >
                                                                {(() => {
                                                                    const displayName = pickup?.consignee_name || row.user_name || row.retailer_name || '—';
                                                                    const profileImg = row.profile_image || row.user_profile || row.avatar || null;
                                                                    const avatarGrad = getAvatarGradient(row.user_id || displayName);
                                                                    return (
                                                                        <div className="flex items-center gap-2.5">
                                                                            <div className={`w-7 h-7 rounded-full flex-shrink-0 overflow-hidden bg-gradient-to-tr ${avatarGrad} flex items-center justify-center text-white text-[11px] font-bold shadow-xs ring-2 ring-white dark:ring-gray-800`}>
                                                                                {profileImg ? (
                                                                                    <img src={profileImg} alt={displayName} className="w-full h-full object-cover" onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} />
                                                                                ) : null}
                                                                                <span className={`${profileImg ? 'hidden' : 'flex'} items-center justify-center w-full h-full`}>
                                                                                    {displayName.charAt(0).toUpperCase()}
                                                                                </span>
                                                                            </div>
                                                                            <div className="min-w-0">
                                                                                <div className="font-semibold text-gray-800 dark:text-gray-100 text-[12px] truncate max-w-[110px] capitalize group-hover:text-blue-600 transition-colors">
                                                                                    {displayName}
                                                                                </div>
                                                                                <div className="text-[10px] font-mono text-gray-400 dark:text-gray-500 font-normal">
                                                                                    #{row.user_id || '—'}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })()}
                                                            </div>
                                                        </td>
                                                    )}

                                                    {/* Date */}
                                                    <td className={`py-1.5 px-3 text-left align-middle whitespace-nowrap border-y ${cellBorder} ${cellBg} transition-all`}>
                                                        <div className="flex flex-col">
                                                            <span className="font-semibold text-gray-700 dark:text-gray-200 text-[11.5px] leading-tight">
                                                                {row.created_at ? new Date(row.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
                                                            </span>
                                                            {row.created_at && (
                                                                <span className="text-[9.5px] text-gray-400 dark:text-gray-500 font-mono font-normal mt-0.5">
                                                                    {new Date(row.created_at).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' }).toLowerCase()}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>

                                                    {/* Pickup & Delivery Address (Origin & Destination) */}
                                                    <td className={`py-1.5 px-3 align-middle border-y ${cellBorder} ${cellBg} transition-all`}>
                                                        <div className="h-[42px] flex flex-col justify-between min-w-0 relative pl-5 py-1">
                                                            {/* Dotted vertical connector line */}
                                                            <div className="absolute left-[5px] top-[7px] bottom-[7px] w-px border-l-2 border-dotted border-gray-400 dark:border-gray-500" />

                                                            {/* Origin */}
                                                            <div
                                                                className="flex items-center gap-2 min-w-0 relative cursor-default"
                                                                onMouseEnter={(e) => handleAddrEnter(e, row.id, 'pickup', pickup)}
                                                                onMouseLeave={handleAddrLeave}
                                                            >
                                                                <span className="absolute -left-5 w-2.5 h-2.5 rounded-full bg-emerald-500 ring-2 ring-emerald-100 dark:ring-emerald-950/70 shrink-0" />
                                                                <span className="font-medium text-gray-800 dark:text-gray-200 text-[11px] truncate block w-full leading-snug">
                                                                    {pickup.consignee_name || pickup.city || '—'}
                                                                    {pickup.city ? ` (${pickup.city}${pickup.zip ? ' - ' + pickup.zip : ''})` : ''}
                                                                </span>
                                                            </div>

                                                            {/* Destination */}
                                                            <div
                                                                className="flex items-center gap-2 min-w-0 relative cursor-default"
                                                                onMouseEnter={(e) => handleAddrEnter(e, row.id, 'dropoff', dropoff)}
                                                                onMouseLeave={handleAddrLeave}
                                                            >
                                                                <span className="absolute -left-5 w-2.5 h-2.5 rounded-full bg-indigo-600 ring-2 ring-indigo-100 dark:ring-indigo-950/70 shrink-0" />
                                                                <span className="font-semibold text-indigo-600 dark:text-indigo-400 text-[11px] truncate block w-full leading-snug">
                                                                    {dropoff.consignee_name || dropoff.city || '—'}
                                                                    {dropoff.city ? ` (${dropoff.city}${dropoff.zip ? ' - ' + dropoff.zip : ''})` : ''}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Product Details */}
                                                    <td
                                                        className={`py-1.5 px-3 align-middle border-y ${cellBorder} ${cellBg} transition-all cursor-pointer`}
                                                        onMouseEnter={(e) => handleProductEnter(e, row.id, row)}
                                                        onMouseLeave={handleProductLeave}
                                                    >
                                                        <div className="font-semibold text-gray-800 dark:text-gray-100 text-[11.5px] truncate max-w-[125px] leading-tight capitalize">
                                                            {description || '—'}
                                                        </div>
                                                        <div className="font-bold text-gray-800 dark:text-gray-200 text-[12px] mt-0.5 tracking-tight">
                                                            ₹{parseFloat(row.debit_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                        </div>
                                                    </td>

                                                    {/* Freight */}
                                                    <td className={`py-1.5 px-3 text-center align-middle border-y ${cellBorder} ${cellBg} transition-all`}>
                                                        <span
                                                            className="inline-flex px-2.5 py-0.5 text-[9px] font-bold rounded-full border border-indigo-200 dark:border-indigo-800 bg-indigo-50 dark:bg-indigo-950/50 text-indigo-700 dark:text-indigo-300 shadow-2xs cursor-default"
                                                            onMouseEnter={(e) => handleTypeEnter(e, row.id, shipmentType)}
                                                            onMouseLeave={handleTypeLeave}
                                                        >
                                                            {shipmentTypeShortMap[shipmentType] || shipmentType}
                                                        </span>
                                                    </td>

                                                    {/* Box Count & Weight */}
                                                    <td className={`py-1.5 px-3 text-center align-middle border-y ${cellBorder} ${cellBg} transition-all`}>
                                                        <div
                                                            className="inline-flex flex-col items-center justify-center cursor-pointer group/box py-0.5 px-2 rounded-lg hover:bg-slate-100/70 dark:hover:bg-white/[0.04] transition-colors"
                                                            onMouseEnter={(e) => handleWeightEnter(e, row.id, row)}
                                                            onMouseLeave={handleWeightLeave}
                                                        >
                                                            <div className="text-[12px] font-bold text-gray-800 dark:text-gray-100 leading-tight flex items-center justify-center gap-1">
                                                                <span>{row.total_boxes || 0}</span>
                                                                <FaBox size={10} className="text-amber-500/90 dark:text-amber-400 shrink-0 group-hover/box:scale-110 transition-transform" />
                                                            </div>
                                                            <div className="text-[10.5px] font-medium text-gray-500 dark:text-gray-400 leading-tight mt-0.5">
                                                                {row.total_weight || 0} kg
                                                            </div>
                                                        </div>
                                                    </td>

                                                    {/* Status */}
                                                    <td className={`py-1.5 px-3 text-center align-middle border-y ${cellBorder} ${isRowRefreshing ? 'bg-indigo-50/70 dark:bg-indigo-950/40' : cellBg} transition-all`}>
                                                        {isRowRefreshing ? (
                                                            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-[10.5px] font-bold text-indigo-700 dark:text-indigo-300 bg-indigo-100/90 dark:bg-indigo-900/60 rounded-full border border-indigo-300 dark:border-indigo-700 shadow-xs">
                                                                <svg className="animate-spin h-3 w-3 text-indigo-600 dark:text-indigo-400 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                                                                </svg>
                                                                <span className="tracking-wide">Updating...</span>
                                                            </span>
                                                        ) : (
                                                            <span
                                                                className={`inline-flex items-center justify-center min-w-[38px] px-2.5 py-0.5 text-[10.5px] font-bold rounded-full cursor-default transition-all duration-150 hover:scale-105 shadow-xs ${statusCfg.badgeClass}`}
                                                                onMouseEnter={(e) => handleStatusEnter(e, row.id, readableStatus)}
                                                                onMouseLeave={handleStatusLeave}
                                                            >
                                                                {statusCfg.label}
                                                            </span>
                                                        )}
                                                    </td>

                                                    {/* Actions */}
                                                    <td className={`py-1.5 px-3 text-center align-middle rounded-r-2xl border-y border-r ${cellBorder} ${isRowRefreshing ? 'bg-indigo-50/70 dark:bg-indigo-950/40' : cellBg} transition-all`}>
                                                        {isRowRefreshing ? (
                                                            <div className="w-7 h-7 inline-flex items-center justify-center text-indigo-600 dark:text-indigo-400" title="Updating shipment...">
                                                                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                                                                </svg>
                                                            </div>
                                                        ) : (
                                                            <div className="relative inline-block text-left action-dropdown-wrapper">
                                                                <button
                                                                    onClick={(e) => {
                                                                        if (showActionDropdown === row.order_id) {
                                                                            setShowActionDropdown(null);
                                                                        } else {
                                                                            const rect = e.currentTarget.getBoundingClientRect();
                                                                            setActionDropdownPos({
                                                                                x: rect.right,
                                                                                y: rect.bottom,
                                                                                top: rect.top,
                                                                                bottom: rect.bottom,
                                                                                left: rect.left,
                                                                                right: rect.right,
                                                                            });
                                                                            setShowActionDropdown(row.order_id);
                                                                        }
                                                                    }}
                                                                    className="w-7 h-7 rounded-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:border-gray-300 hover:bg-gray-50 text-gray-500 hover:text-gray-800 transition-all shadow-xs inline-flex items-center justify-center cursor-pointer active:scale-90"
                                                                    title="Actions"
                                                                >
                                                                    <BsThreeDotsVertical size={13} />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        {paginatedData.length === 0 && (
                                            <tr>
                                                <td colSpan={isAdmin ? 10 : 9} className="py-14 text-center text-gray-400 dark:text-indigo-300/60 text-xs">
                                                    No shipments found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {isMobileCardView && (
                            <div className="space-y-3">
                                {paginatedData.length === 0 && (
                                    <div className="text-center py-16 text-gray-400 dark:text-indigo-300/60">No shipments found</div>
                                )}
                                {paginatedData.map((row, index) => {
                                    const pickup = row.pickup_location ? JSON.parse(row.pickup_location || '{}') : {};
                                    const dropoff = row.dropoff_location ? JSON.parse(row.dropoff_location || '{}') : {};
                                    const statusLower = row.status?.toLowerCase() || "";
                                    const isManifestPending = ["manifest pending", "lrn pending"].includes(statusLower);
                                    const isPending = statusLower.includes("pending") && !isManifestPending;
                                    const isFailed = statusLower.includes("failed");
                                    const isManifested = statusLower.includes("manifested") || statusLower === "manifest";
                                    const isInTransit = statusLower.includes("in_transit") || statusLower.includes("in transit") || ['left_origin', 'reach_destination', 'out_for_delivery'].some(s => statusLower.includes(s));
                                    const isDelivered = statusLower.includes("delivered") || statusLower.includes("completed");
                                    const isCancelled = statusLower.includes("cancel") || statusLower.includes("rto");
                                    const canBookAppointment = (isManifested || isInTransit) && !isDelivered && !isPending && !isManifestPending && !isFailed && !isCancelled;
                                    const hasWaybill = !!(row.waybill || row.lrn);
                                    const isTrackDisabled = isPending || isManifestPending || !hasWaybill;
                                    let billing = {};
                                    try { billing = JSON.parse(row.billing_address || '{}'); } catch (e) { }

                                    const isCardRefreshing = refreshingOrderId === row.order_id;

                                    return (
                                        <div key={row.id}
                                            className={`bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] rounded-2xl shadow-sm dark:shadow-[0_4px_20px_rgba(79,70,229,0.15)] border overflow-hidden
                                                ${isCardRefreshing
                                                    ? 'border-indigo-400 dark:border-indigo-500 ring-2 ring-indigo-500/50'
                                                    : isFailed
                                                        ? 'border-red-200 dark:border-red-500/40'
                                                        : 'border-gray-200 dark:border-indigo-500/25'
                                                }`}
                                            style={{ animationDelay: `${index * 40}ms` }}
                                        >
                                            <div className={`px-4 py-2.5 flex items-center justify-between
                                                ${isCardRefreshing
                                                    ? 'bg-indigo-50/70 dark:bg-indigo-500/15'
                                                    : isFailed
                                                        ? 'bg-red-50 dark:bg-red-500/10'
                                                        : 'bg-slate-50 dark:bg-indigo-500/5'
                                                }`}>
                                                <div className="flex flex-col items-start gap-1">
                                                    <div className="flex items-center gap-1.5">
                                                        <span
                                                            onClick={() => copyToClipboard(row.order_id, "Order ID")}
                                                            className="font-bold text-sm text-indigo-600 dark:text-indigo-300 cursor-pointer hover:underline"
                                                        >
                                                            #{row.order_id}
                                                        </span>
                                                        <TbRoute
                                                            className="cursor-pointer text-sky-500 hover:text-indigo-600 dark:hover:text-white transition-colors active:scale-95"
                                                            size={16}
                                                            onClick={() => handleOpenTrackingPopup(row)}
                                                            title="Trace shipment"
                                                        />
                                                    </div>
                                                    {isCardRefreshing && (
                                                        <div className="flex items-center gap-1.5 text-[10px] font-semibold text-indigo-600 dark:text-indigo-400 mt-0.5 animate-pulse">
                                                            <svg className="animate-spin h-2.5 w-2.5 text-indigo-600 dark:text-indigo-400 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                                                            </svg>
                                                            <span>Updating shipment...</span>
                                                        </div>
                                                    )}
                                                    {hasWaybill && (
                                                        <div className="flex items-center gap-1.5 flex-wrap">
                                                            <button
                                                                onClick={() => copyToClipboard(row.waybill || row.lrn, "AWB")}
                                                                className="text-[10px] w-fit text-gray-500 dark:text-indigo-300/60 bg-gray-200/50 dark:bg-indigo-500/10 px-2 py-0.5 rounded-md active:scale-95 transition-transform"
                                                            >
                                                                AWB: {row.waybill || row.lrn}
                                                            </button>
                                                            {row.courier_partner && (
                                                                row.courier_partner.toLowerCase().includes("gati") ? (
                                                                    <img src="/assets/images/gati.png?v=4" alt="Gati" className="h-[11px] w-auto max-w-[45px] object-contain" />
                                                                ) : (
                                                                    <span className="text-[10px] text-gray-400 dark:text-indigo-300/60 uppercase font-semibold">
                                                                        {row.courier_partner}
                                                                    </span>
                                                                )
                                                            )}
                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    handleBookAppointment(row);
                                                                }}
                                                                title="Schedule / View Appointment"
                                                                className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] text-purple-600 dark:text-purple-300 bg-purple-50 dark:bg-purple-500/15 border border-purple-200 dark:border-purple-500/30 active:scale-95 transition-all"
                                                            >
                                                                <MdOutlineEventAvailable size={12} />
                                                                <span>Appt</span>
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                                <span className={`px-2.5 py-1 text-[10px] font-semibold rounded-full ${getStatusStyle(row.status)}`}>
                                                    {row.status}
                                                </span>
                                            </div>

                                            <div className="px-4 py-3 space-y-3">
                                                {isAdmin && (
                                                    <div className="flex items-center gap-2 bg-indigo-50 dark:bg-indigo-500/10 rounded-xl px-3 py-2 dark:border dark:border-indigo-500/20">
                                                        <div className="w-8 h-8 rounded-full overflow-hidden bg-gradient-to-br from-indigo-400 to-purple-500 flex items-center justify-center flex-shrink-0">
                                                            {(row.profile_image || row.user_profile || row.avatar)
                                                                ? <img src={row.profile_image || row.user_profile || row.avatar} alt="" className="w-full h-full object-cover" />
                                                                : <span className="text-white font-bold text-[12px]">{(billing.name || row.user_name || 'U').charAt(0).toUpperCase()}</span>
                                                            }
                                                        </div>
                                                        <div>
                                                            <div className="text-xs font-semibold text-gray-700 dark:text-gray-200 capitalize">{billing.name || row.user_name || '—'}</div>
                                                            <div className="text-[10px] text-indigo-500 dark:text-indigo-300">#{row.user_id} {billing.phone ? '· ' + billing.phone : ''}</div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="flex items-start gap-2">
                                                    <div className="flex flex-col items-center mt-1 flex-shrink-0">
                                                        <div className="w-2 h-2 rounded-full bg-emerald-500" />
                                                        <div className="w-0.5 h-6 bg-gray-300 dark:bg-indigo-500/40 my-0.5" />
                                                        <div className="w-2 h-2 rounded-full bg-red-500" />
                                                    </div>
                                                    <div className="flex-1 min-w-0 space-y-2">
                                                        <div>
                                                            <div className="text-xs font-semibold text-gray-700 dark:text-gray-200">{pickup.city || '—'}</div>
                                                            <div className="text-[10px] text-gray-400 dark:text-indigo-300/60 truncate">{pickup.address || ''}</div>
                                                        </div>
                                                        <div>
                                                            <div className="text-xs font-semibold text-gray-700 dark:text-gray-200">{dropoff.city || '—'}</div>
                                                            <div className="text-[10px] text-gray-400 dark:text-indigo-300/60 truncate">{dropoff.address || ''}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-3 gap-2 text-center">
                                                    <div className="bg-gray-50 dark:bg-indigo-500/5 dark:border dark:border-indigo-500/20 rounded-xl py-2">
                                                        <div className="text-xs font-bold text-gray-800 dark:text-white">{row.total_boxes || 0}</div>
                                                        <div className="text-[10px] text-gray-400 dark:text-indigo-300/60">Boxes</div>
                                                    </div>
                                                    <div className="bg-gray-50 dark:bg-indigo-500/5 dark:border dark:border-indigo-500/20 rounded-xl py-2">
                                                        <div className="text-xs font-bold text-gray-800 dark:text-white">{row.total_weight || 0} kg</div>
                                                        <div className="text-[10px] text-gray-400 dark:text-indigo-300/60">{row.total_length && `${row.total_length}×${row.total_width}×${row.total_height}`}</div>
                                                    </div>
                                                    <div className="bg-gray-50 dark:bg-indigo-500/5 dark:border dark:border-indigo-500/20 rounded-xl py-2">
                                                        <div className="text-xs font-bold text-gray-800 dark:text-white">₹{parseFloat(row.debit_amount || 0).toFixed(0)}</div>
                                                        <div className="text-[10px] text-gray-400 dark:text-indigo-300/60">Amount</div>
                                                    </div>
                                                </div>
                                                <div className="text-[10px] text-gray-400 dark:text-indigo-300/60">{new Date(row.created_at).toLocaleDateString('en-IN')}</div>
                                                <div className="flex items-center gap-2 pt-1 border-t border-gray-100 dark:border-indigo-500/20 flex-wrap">
                                                    {isManifestPending && (
                                                        <button
                                                            onClick={() => handleRefreshStatus(row)}
                                                            className="flex items-center gap-1.5 px-3 py-1.5 bg-yellow-50 dark:bg-yellow-500/15 text-yellow-600 dark:text-yellow-300 rounded-lg text-xs font-medium"
                                                        >
                                                            🔄 Refresh Status
                                                        </button>
                                                    )}
                                                    {!isManifestPending && (
                                                        <>
                                                            <button onClick={() => handleViewClick(row)}
                                                                className="flex items-center justify-center flex-1 sm:flex-none gap-2 px-4 py-2 rounded-xl bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 active:scale-95 text-white shadow-md shadow-indigo-500/25 text-xs font-bold transition-all duration-200">
                                                                <FaEye size={14} className="opacity-90" /> View
                                                            </button>
                                                            {canBookAppointment && (
                                                                <button onClick={() => handleBookAppointment(row)}
                                                                    className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-500/15 text-emerald-600 dark:text-emerald-300 rounded-lg text-xs font-medium">
                                                                    <MdOutlineEventAvailable size={13} /> Book Appointment
                                                                </button>
                                                            )}
                                                            {isFailed && (
                                                                <button onClick={() => handleShowFailedReason(row)}
                                                                    className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 dark:bg-red-500/15 text-red-600 dark:text-red-300 rounded-lg text-xs font-medium">
                                                                    <FaExclamationCircle size={12} />
                                                                </button>
                                                            )}
                                                            {isPending && (
                                                                <>
                                                                    <button onClick={() => handleCancelOrder(row.order_id)}
                                                                        className="flex items-center gap-1.5 px-3 py-1.5 bg-red-50 dark:bg-red-500/15 text-red-500 dark:text-red-300 rounded-lg text-xs font-medium">
                                                                        <RxCross2 size={12} /> Cancel
                                                                    </button>
                                                                    <button onClick={() => hanldeShipNow(row)}
                                                                        className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-500/15 text-emerald-600 dark:text-emerald-300 rounded-lg text-xs font-medium">
                                                                        🚚 Ship Now
                                                                    </button>
                                                                </>
                                                            )}
                                                            {!isPending && !isFailed && (
                                                                <div className="relative size-dropdown-wrapper">
                                                                    <button
                                                                        onClick={() => setShowSizeDropdown(showSizeDropdown === row.order_id ? null : row.order_id)}
                                                                        className="flex items-center gap-1.5 px-3 py-1.5 bg-purple-50 dark:bg-purple-500/15 text-purple-600 dark:text-purple-300 rounded-lg text-xs font-medium"
                                                                    >
                                                                        <FcPrint size={13} /> Print
                                                                    </button>
                                                                    {showSizeDropdown === row.order_id && (
                                                                        <div className="absolute left-0 bottom-full mb-2 bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] shadow-xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] rounded-xl p-1 z-50 w-36 border border-gray-200 dark:border-indigo-500/30">
                                                                            {labelSizes.map(s => (
                                                                                <div key={s.value} onClick={() => handlePrintLabel(row.order_id, s.value)}
                                                                                    className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-indigo-500/15 cursor-pointer text-sm rounded-lg flex items-center gap-2 dark:text-indigo-100">
                                                                                    <FcPrint size={13} /> Label {s.label}
                                                                                </div>
                                                                            ))}
                                                                            {hasWaybill && (
                                                                                <div
                                                                                    onClick={() => handleDownloadWaybill(row.order_id)}
                                                                                    className="px-3 py-2 hover:bg-gray-100 dark:hover:bg-indigo-500/15 cursor-pointer text-sm rounded-lg flex items-center gap-2 border-t border-gray-100 dark:border-indigo-500/20 mt-1 text-purple-600 dark:text-purple-300 font-medium"
                                                                                >
                                                                                    <FaDownload size={13} /> Waybill / E-Waybill
                                                                                </div>
                                                                            )}
                                                                            {!hasWaybill && (
                                                                                <div className="px-3 py-2 text-xs text-gray-400 dark:text-indigo-300/60 italic">
                                                                                    Waybill not generated yet
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                            {isDelivered && (
                                                                <button
                                                                    onClick={() => handleDownloadPOD(row)}
                                                                    className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-50 dark:bg-emerald-500/15 text-emerald-600 dark:text-emerald-300 rounded-lg text-xs font-medium"
                                                                >
                                                                    <FaDownload size={12} /> POD
                                                                </button>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {totalPages > 1 && (
                            <div className="flex justify-center mt-8">
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={(e, v) => setCurrentPage(v)}
                                    variant="outlined"
                                    shape="rounded"
                                    size="small"
                                    className="pagination"
                                    renderItem={(item) => (
                                        <PaginationItem
                                            {...item}
                                            className="mx-1 rounded-md"
                                            style={{
                                                color: isDarkMode ? '#c7d2fe' : '#000000',
                                                borderColor: isDarkMode ? 'rgba(99,102,241,0.4)' : 'rgba(0,0,0,0.3)',
                                                backgroundColor: item.selected
                                                    ? (isDarkMode ? 'rgb(79,70,229)' : '#1976d2')
                                                    : 'transparent',
                                                ...(item.selected ? { color: '#ffffff' } : {}),
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {failedReasonPopup.open && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 dark:bg-black/70 backdrop-blur-sm">
                        <div className="bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] rounded-2xl shadow-2xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] p-6 w-full max-w-md mx-4 border border-red-200 dark:border-red-500/40">
                            <div className="flex items-center gap-3 mb-4">
                                <div className="w-10 h-10 rounded-full bg-red-100 dark:bg-red-500/20 flex items-center justify-center flex-shrink-0">
                                    <FaExclamationCircle className="text-red-600 dark:text-red-400" size={20} />
                                </div>
                                <div>
                                    <h3 className="font-bold text-gray-800 dark:text-white text-lg">Failure Reason</h3>
                                    <p className="text-xs text-gray-500 dark:text-indigo-300/60">Order #{failedReasonPopup.orderId}</p>
                                </div>
                            </div>
                            <div className="bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/40 rounded-xl p-4 mb-5">
                                <p className="text-sm text-red-700 dark:text-red-300 leading-relaxed">{failedReasonPopup.reason}</p>
                            </div>
                            <button
                                onClick={() => setFailedReasonPopup({ open: false, reason: '', orderId: '' })}
                                className="w-full py-2.5 bg-gray-800 dark:bg-gradient-to-r dark:from-indigo-600 dark:to-purple-600 dark:hover:from-indigo-500 dark:hover:to-purple-500 dark:shadow-lg dark:shadow-indigo-900/50 text-white rounded-xl text-sm font-medium hover:bg-gray-700 dark:hover:bg-gray-600 transition-colors"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}

                <B2BViewAllShipment
                    isopen={isViewOpen}
                    onClose={() => setIsViewOpen(false)}
                    shipment={selectedShipment}
                    wareHouses={wareHouseList}
                    fetchOrderData={fetchAllShipments}
                />

                <B2BViewRateForword
                    isopen={isEstimatorOpen}
                    onClose={() => setIsEstimatorOpen(false)}
                    data={shipData}
                    shipment={selectedShipment}
                    onSuccess={handleShipNowSuccess}
                    fetchOrderData={fetchAllShipments}
                />

                <AppointmentModal
                    isopen={openAppointmentModal}
                    onClose={modelcloseAppoiment}
                    orderId={appoimentOrderId}
                    shipment={appointmentShipmentData}
                    onSuccess={() => fetchAllShipments(true)}
                />

                <B2BTrackingSidePopup
                    isOpen={isTrackingPopupOpen}
                    onClose={() => setIsTrackingPopupOpen(false)}
                    searchTerm={trackingPopupSearchTerm}
                    setSearchTerm={setTrackingPopupSearchTerm}
                    isDarkMode={isDarkMode}
                />

                <B2BForwordShipment
                    isOpen={isAddShipmentOpen}
                    onClose={() => setIsAddShipmentOpen(false)}
                    onCreated={handleShipmentCreated}
                />

                <B2BUploadBulk
                    isopen={uploadBulkPopupOpen}
                    onClose={handleCloseUploadBulk}
                    onUploadSuccess={fetchAllShipments}
                    onBulkOrdersCreated={handleBulkOrdersCreated}
                />
            </div>
        </>
    );
};

export default B2bAllShipmentList;